import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from "../store/store.js"
import Cookie from "js-cookie"
import * as api from "../api/api.js"

import HelloWorld from '@/components/HelloWorld'
import HomePage from '../views/homepage'
//文档内容首页
import DocumentIndex from '../views/documents/documentIndex'
//文档首页
import DocHomePage from '../views/documents/docHomePage'
//********************************接入指南************************************//
//API接入流程
import ApiAccess from '../views/documents/guide/apiAccess'
//用户鉴权服务方案
import UserService from '../views/documents/guide/userService'
//*******************************SKFace-IOS************************************//
//iOS人脸识别使用说明
import SkfaceiosHelp from '../views/documents/skfaceios/skfaceiosHelp'
//----------------------------基础接口-------------------------------//
//iOS人脸识别 SDK初始化
import SDKInitial from '../views/documents/skfaceios/basics/SDKInitial'
//iOS人脸识别 释放SDK资源
import ReleaseSDK from '../views/documents/skfaceios/basics/releaseSDK'
//iOS人脸识别 视频人脸检测与跟踪初始化
import FaceInitial from '../views/documents/skfaceios/basics/faceInitial'
//iOS人脸识别 视频人脸检测与跟踪
import FaceTrack from '../views/documents/skfaceios/basics/faceTrack'
//iOS人脸识别 设置人脸识别阈值
import SetFace from '../views/documents/skfaceios/basics/setFace'
//iOS人脸识别 获取人脸识别阈值
import GetFace from '../views/documents/skfaceios/basics/getFace'
//----------------------------本地人脸管理接口-------------------------------//
//iOS人脸识别 开启人脸注册
import OpenFaceRegister from '../views/documents/skfaceios/localface/openFaceRegister'
//iOS人脸识别 停止人脸注册
import StopFaceRegister from '../views/documents/skfaceios/localface/stopFaceRegister'
//iOS人脸识别 删除人员信息
import DeletePerson from '../views/documents/skfaceios/localface/deletePerson'
//iOS人脸识别 设置人脸属性
import SetFaceAttribute from '../views/documents/skfaceios/localface/setFaceAttribute'
//iOS人脸识别 设置识别记录的缓存上限
import SetUpperLimit from '../views/documents/skfaceios/localface/setUpperLimit'
//iOS人脸识别 获取认识的人员数量及列表
import GetPersonList from '../views/documents/skfaceios/localface/getPersonList'
//iOS人脸识别 获取认识人员的详细信息
import GetPersonDetails from '../views/documents/skfaceios/localface/getPersonDetails'
//----------------------------事件接口--------------------------------//
//iOS人脸识别 设置事件监听
import SetEventMonitor from '../views/documents/skfaceios/event/setEventMonitor'
//iOS人脸识别 短时记忆功能
import ShortTimeMemory from '../views/documents/skfaceios/event/shortTimeMemory'
//----------------------------FRM相关接口--------------------------------//
//iOS人脸识别 提取FRM绑定码信息
import GetFRMBindCode from '../views/documents/skfaceios/frm/getFRMBindCode'
//iOS人脸识别 绑定FRM
import BindFRM from '../views/documents/skfaceios/frm/bindFRM'
//iOS人脸识别 解绑FRM
import UntyingFRM from '../views/documents/skfaceios/frm/untyingFRM'
//iOS人脸识别 获取本机当前绑定信息
import GetBindInformation from '../views/documents/skfaceios/frm/getBindInformation'
//iOS人脸识别 获取当前终端所拥有的人员分组结构
import GetDeviceAllGroup from '../views/documents/skfaceios/frm/getDeviceAllGroup'
//iOS人脸识别 获取FRM终端名称
import GetFRMDeviceName from '../views/documents/skfaceios/frm/getFRMDeviceName'
//iOS人脸识别 通过人员组ID获得人员组路径信息
import GetPath from '../views/documents/skfaceios/frm/getPath'
//iOS人脸识别 人员本地ID转换为云端对应ID
import TransformationID from '../views/documents/skfaceios/frm/transformationID'
//----------------------------图片处理相关接口--------------------------------//
//iOS人脸识别 图片人脸检测与分析
import FaceTesting from '../views/documents/skfaceios/image/faceTesting'
//iOS人脸识别 人脸特征对比
import FaceContrast from '../views/documents/skfaceios/image/faceContrast'
//----------------------------SDK版本信息接口--------------------------------//
//iOS人脸识别 获取SDK版本号
import GetSDKVersion from '../views/documents/skfaceios/sdkedition/getSDKVersion'
//iOS人脸识别 获取人脸识别内核版本号
import GetFaceKernel from '../views/documents/skfaceios/sdkedition/getFaceKernel'
//iOS人脸识别 获得Model版本号
import GetModeVersion from '../views/documents/skfaceios/sdkedition/getModeVersion'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   SKFaceSDKFamily  **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceSDKfamily人脸识别 使用说明 family
import SKFaceSDKFamilyHelp from '../views/documents/SKFaceSDKFamily/SKFacesdkfamilyUserHelp'
//----------------------------基础接口-------------------------------//
// SKFaceSDKfamily人脸识别 SDK初始化
import SKFaceSDKFamilyInitial from '../views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyInitial'
// SKFaceSDKfamily人脸识别 获取SDK版本号
import SKFaceSDKFamilyeVersion from '../views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyVersion'
// SKFaceSDKfamily人脸识别 获得人脸识别内核版本号
import SKFaceSDKFamilyKernel from '../views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyKernel'
// SKFaceSDKfamily人脸识别 获得Model版本号
import SKFaceSDKFamilyModel from '../views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyModel'
// SKFaceSDKfamily人脸识别 释放SDK资源
import SKFaceSDKFamilyReleaseSDK from '../views/documents/SKFaceSDKFamily/basics/SKFacesdkfamilyReleaseSDK'
//----------------------------Image版检测相关接口-------------------------------//
//SKFaceSDKfamily人脸识别 Image版人脸检测
import SkfaceSDKFamilyFcetest from '../views/documents/SKFaceSDKFamily/image/IMGfamilyFcetest'
//SKFaceSDKfamily人脸识别 人脸特征对比
import SkfaceSDKFamilyFceContrast from '../views/documents/SKFaceSDKFamily/image/IMGfamilyFceContrast'
//----------------------------Video版检测相关接口-------------------------------//
//SKFaceSDKLive视频初始化	
import SkfaceSDKFamilyVoideinitiali from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideInitialization'
//SKFaceSDKLive设置“陌生人短时记忆功能”打开、关闭	
import SkfaceSDKFamilyVoideStranger from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideStranger'
//SKFaceSDKLive Video版人脸检测与跟踪
import SkfaceSDKFamilyVoideDetection from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideDetection'
//SKFaceSDKLive Video获取FRM绑定信息
import SkfaceSDKFamilyVoideFrm from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideFrmInformation'
//SKFaceSDKLive Video获取本机当前绑定信息
import SkfaceSDKFamilyVoideLocal from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideLocal'
//SKFaceSDKLive Video绑定FRM
import SkfaceSDKFamilyVoideBindingfrm from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideBindingfrm'
//SKFaceSDKLive Video解绑FRM
import SkfaceSDKFamilyVoideUntying from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideUntyingfrm'
//SKFaceSDKLive Video设置事件监听
import SkfaceSDKFamilyVoideSeetingmonitor from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideSeetingmonitor'
//SKFaceSDKLive Video开始人脸注册
import SkfaceSDKFamilyVoideFaceregister from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideFaceregister'
//SKFaceSDKLive Video取消人脸注册
import SkfaceSDKFamilyVoideCancelfaceregister from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideCancelfaceregister'
//SKFaceSDKLive Video获取人的详细信息   
import SkfaceSDKFamilyVoideGetpeople from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideGetpeople'
//SKFaceSDKLive Video设置名字
import SkfaceSDKFamilyVoidePeoplename from '../views/documents/SKFaceSDKFamily/voideinitiali/VoidePeoplename'
//SKFaceSDKLive Video设置性别
import SkfaceSDKFamilyVoideSex from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideSex'
//SKFaceSDKLive Video设置生日
import SkfaceSDKFamilyVoideBrithday from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideBrithday'
//SKFaceSDKLive Video设置细节
import SkfaceSDKFamilyVoideDetails from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideDetails'
//SKFaceSDKLive Video删除一个人
import SkfaceSDKFamilyVoidedeLetepeople from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideDeLetepeople'
//SKFaceSDKLive Video获取当前设备所关联人员库Person数量
import SkfaceSDKFamilyVoideGetperson from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideGetperson'
//SKFaceSDKLive Video获取认识的人列表
import SkfaceSDKFamilyVoidePeopleselect from '../views/documents/SKFaceSDKFamily/voideinitiali/VoidePeopleselect'
//SKFaceSDKLive Video获取设备名称
import SkfaceSDKFamilyVoideSetequipment from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideSetequipment'
//SKFaceSDKLive 获取当前设备所拥有的人员分组结构
import SkfaceSDKFamilyVoideGrouping from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideGrouping'
//SKFaceSDKLive 人员本地ID转换为云端对应ID
import SkfaceSDKFamilyVoideTransformation from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideTransformation'
//SKFaceSDKLive 设置人脸识别阈值
import SkfaceSDKFamilyVoideThreshold from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideThreshold'
//SKFaceSDKLive 人员的组ID转换为人员所在组的路径
import SkfaceSDKFamilyVoideRouter from '../views/documents/SKFaceSDKFamily/voideinitiali/VoideRouter'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   SKFaceSDKLite    **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceSDKLite人脸识别 使用说明
import SKFaceSDKLiteHelp from '../views/documents/skfacesdklite/SKFacesdkliteUserHelp'
//----------------------------基础接口-------------------------------//
// SKFaceSDKLite人脸识别 SDK初始化
import SKFaceSDKLiteInitial from '../views/documents/skfacesdklite/basics/SKFacesdkliteInitial'
// SKFaceSDKLite人脸识别 释放SDK资源
import SKFaceSDKLiteVersion from '../views/documents/skfacesdklite/basics/SKFacesdkliteVersion'
// SKFaceSDKLite人脸识别 视频人脸识别与跟踪初始化
import SKFaceSDKLiteDistinguishTrack from '../views/documents/skfacesdklite/basics/SKFacesdkliteDistinguishTrack'
// SKFaceSDKLite人脸识别 视频人脸检测与跟踪
import SKFaceSDKLiteTrack from '../views/documents/skfacesdklite/basics/SKFacesdkliteTrack'
//----------------------------版本信息接口-------------------------------//
// SKFaceSDKLite人脸识别 获取SDK版本号
import SKFaceSDKLiteEdition from '../views/documents/skfacesdklite/Edition/SKFacesdkliteEdition'
// SKFaceSDKLite人脸识别 获得人脸识别内核版本号
import SKFaceSDKLiteKernel from '../views/documents/skfacesdklite/Edition/SKFacesdkliteKernel'
// SKFaceSDKLite人脸识别 获得Model版本号
import SKFaceSDKLiteModel from '../views/documents/skfacesdklite/Edition/SKFacesdkModel'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   SKFaceSDKLive    **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceSDKLive人脸识别 使用说明
import SKFaceSDKLiveHelp from '../views/documents/skfacesdklive/SKFacesdkliveUserHelp'
//----------------------------基础接口-------------------------------//
// SKFaceSDKLive人脸识别 SDK初始化
import SKFaceSDKLiveInitial from '../views/documents/skfacesdklive/basics/SKFacesdkliveInitial'
// SKFaceSDKLive人脸识别 获取SDK版本号
import SKFaceSDKLiveVersion from '../views/documents/skfacesdklive/basics/SKFacesdkliveVersion'
// SKFaceSDKLive人脸识别 获得人脸识别内核版本号
import SKFaceSDKLiveKernel from '../views/documents/skfacesdklive/basics/SKFacesdkliveKernel'
// SKFaceSDKLive人脸识别 获得Model版本号
import SKFaceSDKLiveModel from '../views/documents/skfacesdklive/basics/SKFacesdkliveModel'
// SKFaceSDKLive人脸识别 释放SDK资源
import SKFaceSDKLiveReleaseSDK from '../views/documents/skfacesdklive/basics/SKFacesdkliveReleaseSDK'
//----------------------------Image版检测相关接口-------------------------------//
//SKFaceSDK-Android人脸识别 Image版人脸检测
import SkfaceSDKLiveFcetest from '../views/documents/skfacesdklive/image/IMGliveFcetest'
//SKFaceSDK-Android人脸识别 人脸特征对比
import SkfaceSDKLiveFceContrast from '../views/documents/skfacesdklive/image/IMGliveFceContrast'
//----------------------------Video版检测相关接口-------------------------------//
//SKFaceSDKLive视频初始化	
import SkfaceSDKLiveVoideinitiali from '../views/documents/skfacesdklive/voideinitiali/VoideInitialization'
//SKFaceSDKLive设置“陌生人短时记忆功能”打开、关闭	
import SkfaceSDKLiveVoideStranger from '../views/documents/skfacesdklive/voideinitiali/VoideStranger'
//SKFaceSDKLive Video版人脸检测与跟踪
import SkfaceSDKLiveVoideDetection from '../views/documents/skfacesdklive/voideinitiali/VoideDetection'
// //SKFaceSDKLive Video活体检测
import SkfaceSDKLiveVoideLiving from '../views/documents/skfacesdklive/voideinitiali/VoideLivinga'
// //SKFaceSDKLive Video人证对比
import SkfaceSDKLiveVoideWitness from '../views/documents/skfacesdklive/voideinitiali/VoideWitness'
//SKFaceSDKLive Video获取FRM绑定信息
import SkfaceSDKLiveVoideFrm from '../views/documents/skfacesdklive/voideinitiali/VoideFrmInformation'
//SKFaceSDKLive Video获取本机当前绑定信息
import SkfaceSDKLiveVoideLocal from '../views/documents/skfacesdklive/voideinitiali/VoideLocal'
//SKFaceSDKLive Video绑定FRM
import SkfaceSDKLiveVoideBindingfrm from '../views/documents/skfacesdklive/voideinitiali/VoideBindingfrm'
//SKFaceSDKLive Video解绑FRM
import SkfaceSDKLiveVoideUntying from '../views/documents/skfacesdklive/voideinitiali/VoideUntyingfrm'
//SKFaceSDKLive Video设置事件监听
import SkfaceSDKLiveVoideSeetingmonitor from '../views/documents/skfacesdklive/voideinitiali/VoideSeetingmonitor'
//SKFaceSDKLive Video开始人脸注册
import SkfaceSDKLiveVoideFaceregister from '../views/documents/skfacesdklive/voideinitiali/VoideFaceregister'
//SKFaceSDKLive Video取消人脸注册
import SkfaceSDKLiveVoideCancelfaceregister from '../views/documents/skfacesdklive/voideinitiali/VoideCancelfaceregister'
//SKFaceSDKLive Video获取人的详细信息   
import SkfaceSDKLiveVoideGetpeople from '../views/documents/skfacesdklive/voideinitiali/VoideGetpeople'
//SKFaceSDKLive Video设置名字
import SkfaceSDKLiveVoidePeoplename from '../views/documents/skfacesdklive/voideinitiali/VoidePeoplename'
//SKFaceSDKLive Video设置性别
import SkfaceSDKLiveVoideSex from '../views/documents/skfacesdklive/voideinitiali/VoideSex'
//SKFaceSDKLive Video设置生日
import SkfaceSDKLiveVoideBrithday from '../views/documents/skfacesdklive/voideinitiali/VoideBrithday'
//SKFaceSDKLive Video设置细节
import SkfaceSDKLiveVoideDetails from '../views/documents/skfacesdklive/voideinitiali/VoideDetails'
//SKFaceSDKLive Video删除一个人
import SkfaceSDKLiveVoidedeLetepeople from '../views/documents/skfacesdklive/voideinitiali/VoideDeLetepeople'
//SKFaceSDKLive Video获取当前设备所关联人员库Person数量
import SkfaceSDKLiveVoideGetperson from '../views/documents/skfacesdklive/voideinitiali/VoideGetperson'
//SKFaceSDKLive Video获取认识的人列表
import SkfaceSDKLiveVoidePeopleselect from '../views/documents/skfacesdklive/voideinitiali/VoidePeopleselect'
//SKFaceSDKLive Video获取设备名称
import SkfaceSDKLiveVoideSetequipment from '../views/documents/skfacesdklive/voideinitiali/VoideSetequipment'
//SKFaceSDKLive 获取当前设备所拥有的人员分组结构
import SkfaceSDKLiveVoideGrouping from '../views/documents/skfacesdklive/voideinitiali/VoideGrouping'
//SKFaceSDKLive 人员本地ID转换为云端对应ID
import SkfaceSDKLiveVoideTransformation from '../views/documents/skfacesdklive/voideinitiali/VoideTransformation'
//SKFaceSDKLive 设置人脸识别阈值
import SkfaceSDKLiveVoideThreshold from '../views/documents/skfacesdklive/voideinitiali/VoideThreshold'
//SKFaceSDKLive 人员的组ID转换为人员所在组的路径
import SkfaceSDKLiveVoideRouter from '../views/documents/skfacesdklive/voideinitiali/VoideRouter'
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************ SKFaceSDK-Android **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceSDK-Android人脸识别使用说明
import SkfaceSdkAndroidHelp from '../views/documents/skfacesdkandroid/skfaceAndroidUserHelp'
//----------------------------基础接口-------------------------------//
//SKFaceSDK-Android人脸识别 SDK初始化与释放
import SkfaceSdkInitializationRelease from '../views/documents/skfacesdkandroid/basics/SkfaceSdkInitializationRelease'
//SKFaceLive-Android人脸识别 视频人脸检测与识别
import SkfaceSdkVideoDetectionRecognition from '../views/documents/skfacesdkandroid/basics/SkfaceSdkVideoDetectionRecognition'
//SKFaceLive-Android人脸识别 设置与获取人脸识别阈值
import SkfaceSdkethreshold from '../views/documents/skfacesdkandroid/basics/SkfaceSdkethreshold'
//----------------------------拓展接口-------------------------------//
//SKFaceSDK-Android人脸识别 人脸记忆功能
import SkfaceSdkFacememory from '../views/documents/skfacesdkandroid/expand/faceConttest'
//SKFaceSDK-Android人脸识别 清除缓存
import SkfaceSdkClearcache from '../views/documents/skfacesdkandroid/expand/Clearcache'
//SKFaceSDK-Android人脸识别 获取终端ID
import SkfaceSdkGetterminalID from '../views/documents/skfacesdkandroid/expand/GetterminalID'
//SKFaceSDK-Android人脸识别 设置图像数据格式
import SkfaceSdkSettingImageFormat from '../views/documents/skfacesdkandroid/expand/SettingImageFormat'
//----------------------------本地人连管理接口-------------------------------//
//SKFaceSDK-Android人脸识别 开启与停止人脸注册
import SkfaceSdkOpenandStop from '../views/documents/skfacesdkandroid/localfacemanagement/OpenandStop'
//SKFaceSDK-Android人脸识别 删除人员信息
import SkfaceSdkDeletepersonnel from '../views/documents/skfacesdkandroid/localfacemanagement/Deletepersonnel'
//SKFaceSDK-Android人脸识别 设置人脸属性
import SkfaceSdkSettingFaceProperties from '../views/documents/skfacesdkandroid/localfacemanagement/SettingFaceProperties'
//SKFaceSDK-Android人脸识别 获取本地人员识别信息
import SkfaceSdkLocalPersonnel from '../views/documents/skfacesdkandroid/localfacemanagement/LocalPersonnel'
//SKFaceSDK-Android人脸识别 设置识别记录的缓存上限
import SkfaceSdkRecordcache from '../views/documents/skfacesdkandroid/localfacemanagement/Recordcache'
//----------------------------事件接口-------------------------------//
//SKFaceSDK-Android人脸识别 设置事件监听
import SkfaceSdkSettingeventmonitoring from '../views/documents/skfacesdkandroid/eventinterface/Settingeventmonitoring'
//----------------------------FRM接口-------------------------------//
//SKFaceSDK-Android人脸识别 绑定/解绑FRM
import SkfaceSdkUnbound from '../views/documents/skfacesdkandroid/frm/Unbound'
//SKFaceSDK-Android人脸识别 获取FRM终端名称
import SkfaceSdkGettingfrmterminals from '../views/documents/skfacesdkandroid/frm/Gettingfrmterminals'
//SKFaceSDK-Android人脸识别 获取人员组的路径信息
import SkfaceSdkPersonnelgrouppath from '../views/documents/skfacesdkandroid/frm/Personnelgrouppath'
//SKFaceSDK-Android人脸识别 本地人员ID的云端同步
import SkfaceSdkLocalstaff from '../views/documents/skfacesdkandroid/frm/Localstaff'
//SKFaceSDK-Android人脸识别 获取终端人员组织架构信息
import SkfaceSdkOrganizationalArchitecture  from '../views/documents/skfacesdkandroid/frm/OrganizationalArchitecture'
//----------------------------图片处理相关接口-------------------------------//
//SKFaceSDK-Android 图片人脸检测与分析	
import SkfaceSdkimgFaceDetection from '../views/documents/skfacesdkandroid/img/imgFaceDetection'
//SKFaceSDK-Android 人脸特征比对	
import SkfaceSdkFeaturecomparison from '../views/documents/skfacesdkandroid/img/Featurecomparison'
//----------------------------版本信息接口-------------------------------//
//SKFaceSDK-Android 获取SDK版本号	
import SkfaceSdkGetversionnumber from '../views/documents/skfacesdkandroid/Edition/Getversionnumber'
//SKFaceSDK-Android 获取人脸识别内核版本号	
import SkfaceSdkKernelversion from '../views/documents/skfacesdkandroid/Edition/Kernelversion'
//SKFaceSDK-Android 获取Model版本号	
import SkfaceSdkModelEdition from '../views/documents/skfacesdkandroid/Edition/ModelEdition'

//----------------------------Video版检测相关接口-------------------------------//
//SKFaceSDK-Android视频初始化	
import SkfaceSdkAndroidVoideinitiali from '../views/documents/skfacesdkandroid/voideinitiali/voideinitialization'
//SKFaceSDK-Android设置“陌生人短时记忆功能”打开、关闭
import SkfaceSdkAndroidVoidestranger from '../views/documents/skfacesdkandroid/voideinitiali/voidestranger'
//SKFaceSDK-Android10Video版人脸检测与跟踪
import SkfaceSdkAndroidVoideDetection from '../views/documents/skfacesdkandroid/voideinitiali/voidedetection'
//SKFaceSDK-Android10Video获取FRM绑定信息
import SkfaceSdkAndroidVoidefrm from '../views/documents/skfacesdkandroid/voideinitiali/voidefrminformation'
//SKFaceSDK-Android10Video获取本机当前绑定信息
import SkfaceSdkAndroidVoidelocal from '../views/documents/skfacesdkandroid/voideinitiali/voidelocal'
//SKFaceSDK-Android10Video绑定FRM
import SkfaceSdkAndroidVoidebindingfrm from '../views/documents/skfacesdkandroid/voideinitiali/voidebindingfrm'
//SKFaceSDK-Android10Video解绑FRM
import SkfaceSdkAndroidVoideuntying from '../views/documents/skfacesdkandroid/voideinitiali/voideuntyingfrm'
//SKFaceSDK-Android10Video设置事件监听
import SkfaceSdkAndroidVoideseetingmonitor from '../views/documents/skfacesdkandroid/voideinitiali/voideseetingmonitor'
//SKFaceSDK-Android10Video开始人脸注册
import SkfaceSdkAndroidVoidefaceregister from '../views/documents/skfacesdkandroid/voideinitiali/voidefaceregister'
//SKFaceSDK-Android10Video取消人脸注册
import SkfaceSdkAndroidVoidecancelfaceregister from '../views/documents/skfacesdkandroid/voideinitiali/voidecancelfaceregister'
//SKFaceSDK-Android10Video获取人的详细信息  
import SkfaceSdkAndroidVoidegetpeople from '../views/documents/skfacesdkandroid/voideinitiali/voidegetpeople'
//SKFaceSDK-Android10Video设置名字
import SkfaceSdkAndroidVoidepeoplename from '../views/documents/skfacesdkandroid/voideinitiali/voidepeoplename'
//SKFaceSDK-Android10Video设置性别
import SkfaceSdkAndroidVoidesex from '../views/documents/skfacesdkandroid/voideinitiali/voidesex'
//SKFaceSDK-Android10Video设置生日
import SkfaceSdkAndroidVoidebrithday from '../views/documents/skfacesdkandroid/voideinitiali/voidebrithday'
//SKFaceSDK-Android10Video设置细节
import SkfaceSdkAndroidVoidedetails from '../views/documents/skfacesdkandroid/voideinitiali/voidedetails'
//SKFaceSDK-Android10Video删除一个人
import SkfaceSdkAndroidVoidedeletepeople from '../views/documents/skfacesdkandroid/voideinitiali/voidedeletepeople'
//SKFaceSDK-Android10Video获取当前设备所关联人员库Person数量
import SkfaceSdkAndroidVoidegetperson from '../views/documents/skfacesdkandroid/voideinitiali/voidegetperson'
//SKFaceSDK-Android10Video获取认识的人列表
import SkfaceSdkAndroidVoidepeopleselect from '../views/documents/skfacesdkandroid/voideinitiali/voidepeopleselect'
//SKFaceSDK-Android10Video获取设备名称
import SkfaceSdkAndroidVoidesetequipment from '../views/documents/skfacesdkandroid/voideinitiali/voidesetequipment'
//SKFaceSDK-Android10Video获取当前设备所拥有的人员分组结构
import SkfaceSdkAndroidVoidegrouping from '../views/documents/skfacesdkandroid/voideinitiali/voidegrouping'
//SKFaceSDK-Android10Video人员本地ID转换为云端对应ID
import SkfaceSdkAndroidVoidetransformation from '../views/documents/skfacesdkandroid/voideinitiali/voidetransformation'
//SKFaceSDK-Android10Video设置人脸识别阈值
import SkfaceSdkAndroidVoidethreshold from '../views/documents/skfacesdkandroid/voideinitiali/voidethreshold'
//SKFaceSDK-Android10Video人员的组ID转换为人员所在组的路径
import SkfaceSdkAndroidVoiderouter from '../views/documents/skfacesdkandroid/voideinitiali/voiderouter'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************ SKFaceLive-Windows **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceLive-Windows人脸识别使用说明
import SkfaceLiveWinHelp from '../views/documents/skfacelivewindows/skfaceUserHelp'
//----------------------------基础接口-------------------------------//
//SKFaceLive-Windows人脸识别 SDK初始化
import SkfaceLiveWinSDKInitial from '../views/documents/skfacelivewindows/basics/SDKInitial'
//SKFaceLive-Windows人脸识别 释放SDK资源
import SkfaceLiveWinReleaseSDK from '../views/documents/skfacelivewindows/basics/releaseSDK'
//SKFaceLive-Windows人脸识别 视频人脸检测与跟踪初始化
import SkfaceLiveWinFaceInitial from '../views/documents/skfacelivewindows/basics/faceInitial'
//SKFaceLive-Windows人脸识别 视频人脸检测与跟踪
import SkfaceLiveWinFaceTrack from '../views/documents/skfacelivewindows/basics/faceTrack'
//SKFaceLive-Windows人脸识别 活体视频人脸检测与跟踪
import SkfaceLiveWinFaceLiveTrack from '../views/documents/skfacelivewindows/basics/faceLiveTrack'
//SKFaceLive-Windows人脸识别 视频人证比对与追踪
import SkfaceLiveWinPersonCardTrack from '../views/documents/skfacelivewindows/basics/personCardTrack'
//SKFaceLive-Windows人脸识别 设置人脸识别阈值
import SkfaceLiveWinSetFace from '../views/documents/skfacelivewindows/basics/setFace'
//SKFaceLive-Windows人脸识别 获取人脸识别阈值
import SkfaceLiveWinGetFace from '../views/documents/skfacelivewindows/basics/getFace'
//SKFaceLive-Windows人脸识别 设置人证比对阈值
import SkfaceLiveWinSetPersonAndCard from '../views/documents/skfacelivewindows/basics/setPersonAndCard'
//SKFaceLive-Windows人脸识别 获取人证比对阈值
import SkfaceLiveWinGetPersonAndCard from '../views/documents/skfacelivewindows/basics/getPersonAndCard'
//----------------------------本地人脸管理接口-------------------------------//
//SKFaceLive-Windows人脸识别 开启人脸注册
import SkfaceLiveWinOpenFaceRegister from '../views/documents/skfacelivewindows/localface/openFaceRegister'
//SKFaceLive-Windows人脸识别 停止人脸注册
import SkfaceLiveWinStopFaceRegister from '../views/documents/skfacelivewindows/localface/stopFaceRegister'
//SKFaceLive-Windows人脸识别 删除人员信息
import SkfaceLiveWinDeletePerson from '../views/documents/skfacelivewindows/localface/deletePerson'
//SKFaceLive-Windows人脸识别 设置人脸属性
import SkfaceLiveWinSetFaceAttribute from '../views/documents/skfacelivewindows/localface/setFaceAttribute'
//SKFaceLive-Windows人脸识别 设置识别记录的缓存上限
import SkfaceLiveWinSetUpperLimit from '../views/documents/skfacelivewindows/localface/setUpperLimit'
//SKFaceLive-Windows人脸识别 获取认识的人员数量及列表
import SkfaceLiveWinGetPersonList from '../views/documents/skfacelivewindows/localface/getPersonList'
//SKFaceLive-Windows人脸识别 获取认识人员的详细信息
import SkfaceLiveWinGetPersonDetails from '../views/documents/skfacelivewindows/localface/getPersonDetails'
//----------------------------事件接口--------------------------------//
//SKFaceLive-Windows人脸识别 设置事件监听
import SkfaceLiveWinSetEventMonitor from '../views/documents/skfacelivewindows/event/setEventMonitor'
//SKFaceLive-Windows人脸识别 短时记忆功能
import SkfaceLiveWinShortTimeMemory from '../views/documents/skfacelivewindows/event/shortTimeMemory'
//----------------------------FRM相关接口--------------------------------//
//SKFaceLive-Windows人脸识别 提取FRM绑定码信息
import SkfaceLiveWinGetFRMBindCode from '../views/documents/skfacelivewindows/frm/getFRMBindCode'
//SKFaceLive-Windows人脸识别 绑定FRM
import SkfaceLiveWinBindFRM from '../views/documents/skfacelivewindows/frm/bindFRM'
//SKFaceLive-Windows人脸识别 解绑FRM
import SkfaceLiveWinUntyingFRM from '../views/documents/skfacelivewindows/frm/untyingFRM'
//SKFaceLive-Windows人脸识别 获取本机当前绑定信息
import SkfaceLiveWinGetBindInformation from '../views/documents/skfacelivewindows/frm/getBindInformation'
//SKFaceLive-Windows人脸识别 获取当前终端所拥有的人员分组结构
import SkfaceLiveWinGetDeviceAllGroup from '../views/documents/skfacelivewindows/frm/getDeviceAllGroup'
//SKFaceLive-Windows人脸识别 获取FRM终端名称
import SkfaceLiveWinGetFRMDeviceName from '../views/documents/skfacelivewindows/frm/getFRMDeviceName'
//SKFaceLive-Windows人脸识别 通过人员组ID获得人员组路径信息
import SkfaceLiveWinGetPath from '../views/documents/skfacelivewindows/frm/getPath'
//SKFaceLive-Windows人脸识别 人员本地ID转换为云端对应ID
import SkfaceLiveWinTransformationID from '../views/documents/skfacelivewindows/frm/transformationID'
//----------------------------图片处理相关接口--------------------------------//
//SKFaceLive-Windows人脸识别 图片人脸检测与分析
import SkfaceLiveWinFaceTesting from '../views/documents/skfacelivewindows/image/faceTesting'
//SKFaceLive-Windows人脸识别 人脸特征对比
import SkfaceLiveWinFaceContrast from '../views/documents/skfacelivewindows/image/faceContrast'
//----------------------------SDK版本信息接口--------------------------------//
//SKFaceLive-Windows人脸识别 获取SDK版本号
import SkfaceLiveWinGetSDKVersion from '../views/documents/skfacelivewindows/sdkedition/getSDKVersion'
//SKFaceLive-Windows人脸识别 获取人脸识别内核版本号
import SkfaceLiveWinGetFaceKernel from '../views/documents/skfacelivewindows/sdkedition/getFaceKernel'
//SKFaceLive-Windows人脸识别 获得Model版本号
import SkfaceLiveWinGetModeVersion from '../views/documents/skfacelivewindows/sdkedition/getModeVersion'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   SKFace-Windows   **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKFaceLive-Windows人脸识别使用说明
import SkfaceWinHelp from '../views/documents/skfacewindows/skfaceUserHelp'
//----------------------------基础接口-------------------------------//
//SKFaceLive-Windows人脸识别 SDK初始化
import SkfaceWinSDKInitial from '../views/documents/skfacewindows/basics/SDKInitial'
//SKFaceLive-Windows人脸识别 释放SDK资源
import SkfaceWinReleaseSDK from '../views/documents/skfacewindows/basics/releaseSDK'
//SKFaceLive-Windows人脸识别 视频人脸检测与跟踪初始化
import SkfaceWinFaceInitial from '../views/documents/skfacewindows/basics/faceInitial'
//SKFaceLive-Windows人脸识别 视频人脸检测与跟踪
import SkfaceWinFaceTrack from '../views/documents/skfacewindows/basics/faceTrack'
//SKFaceLive-Windows人脸识别 活体视频人脸检测与跟踪
//import SkfaceWinFaceLiveTrack from '../views/documents/skfacewindows/basics/faceLiveTrack'
//SKFaceLive-Windows人脸识别 视频人证比对与追踪
//import SkfaceWinPersonCardTrack from '../views/documents/skfacewindows/basics/personCardTrack'
//SKFaceLive-Windows人脸识别 设置人脸识别阈值
import SkfaceWinSetFace from '../views/documents/skfacewindows/basics/setFace'
//SKFaceLive-Windows人脸识别 获取人脸识别阈值
import SkfaceWinGetFace from '../views/documents/skfacewindows/basics/getFace'
//SKFaceLive-Windows人脸识别 设置人证比对阈值
//import SkfaceWinSetPersonAndCard from '../views/documents/skfacewindows/basics/setPersonAndCard'
//SKFaceLive-Windows人脸识别 获取人证比对阈值
//import SkfaceWinGetPersonAndCard from '../views/documents/skfacewindows/basics/getPersonAndCard'
//----------------------------本地人脸管理接口-------------------------------//
//SKFaceLive-Windows人脸识别 开启人脸注册
import SkfaceWinOpenFaceRegister from '../views/documents/skfacewindows/localface/openFaceRegister'
//SKFaceLive-Windows人脸识别 停止人脸注册
import SkfaceWinStopFaceRegister from '../views/documents/skfacewindows/localface/stopFaceRegister'
//SKFaceLive-Windows人脸识别 删除人员信息
import SkfaceWinDeletePerson from '../views/documents/skfacewindows/localface/deletePerson'
//SKFaceLive-Windows人脸识别 设置人脸属性
import SkfaceWinSetFaceAttribute from '../views/documents/skfacewindows/localface/setFaceAttribute'
//SKFaceLive-Windows人脸识别 设置识别记录的缓存上限
import SkfaceWinSetUpperLimit from '../views/documents/skfacewindows/localface/setUpperLimit'
//SKFaceLive-Windows人脸识别 获取认识的人员数量及列表
import SkfaceWinGetPersonList from '../views/documents/skfacewindows/localface/getPersonList'
//SKFaceLive-Windows人脸识别 获取认识人员的详细信息
import SkfaceWinGetPersonDetails from '../views/documents/skfacewindows/localface/getPersonDetails'
//----------------------------事件接口--------------------------------//
//SKFaceLive-Windows人脸识别 设置事件监听
import SkfaceWinSetEventMonitor from '../views/documents/skfacewindows/event/setEventMonitor'
//SKFaceLive-Windows人脸识别 短时记忆功能
import SkfaceWinShortTimeMemory from '../views/documents/skfacewindows/event/shortTimeMemory'
//----------------------------FRM相关接口--------------------------------//
//SKFaceLive-Windows人脸识别 提取FRM绑定码信息
import SkfaceWinGetFRMBindCode from '../views/documents/skfacewindows/frm/getFRMBindCode'
//SKFaceLive-Windows人脸识别 绑定FRM
import SkfaceWinBindFRM from '../views/documents/skfacewindows/frm/bindFRM'
//SKFaceLive-Windows人脸识别 解绑FRM
import SkfaceWinUntyingFRM from '../views/documents/skfacewindows/frm/untyingFRM'
//SKFaceLive-Windows人脸识别 获取本机当前绑定信息
import SkfaceWinGetBindInformation from '../views/documents/skfacewindows/frm/getBindInformation'
//SKFaceLive-Windows人脸识别 获取当前终端所拥有的人员分组结构
import SkfaceWinGetDeviceAllGroup from '../views/documents/skfacewindows/frm/getDeviceAllGroup'
//SKFaceLive-Windows人脸识别 获取FRM终端名称
import SkfaceWinGetFRMDeviceName from '../views/documents/skfacewindows/frm/getFRMDeviceName'
//SKFaceLive-Windows人脸识别 通过人员组ID获得人员组路径信息
import SkfaceWinGetPath from '../views/documents/skfacewindows/frm/getPath'
//SKFaceLive-Windows人脸识别 人员本地ID转换为云端对应ID
import SkfaceWinTransformationID from '../views/documents/skfacewindows/frm/transformationID'
//----------------------------图片处理相关接口--------------------------------//
//SKFaceLive-Windows人脸识别 图片人脸检测与分析
import SkfaceWinFaceTesting from '../views/documents/skfacewindows/image/faceTesting'
//SKFaceLive-Windows人脸识别 人脸特征对比
import SkfaceWinFaceContrast from '../views/documents/skfacewindows/image/faceContrast'
//----------------------------SDK版本信息接口--------------------------------//
//SKFaceLive-Windows人脸识别 获取SDK版本号
import SkfaceWinGetSDKVersion from '../views/documents/skfacewindows/sdkedition/getSDKVersion'
//SKFaceLive-Windows人脸识别 获取人脸识别内核版本号
import SkfaceWinGetFaceKernel from '../views/documents/skfacewindows/sdkedition/getFaceKernel'
//SKFaceLive-Windows人脸识别 获得Model版本号
import SkfaceWinGetModeVersion from '../views/documents/skfacewindows/sdkedition/getModeVersion'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************     SKEye-iOS      **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKEye-iOS物体识别使用说明
import SKEyeiOSUserHelp from '../views/documents/skeyeios/SKEyeUserHelp'
// SKEye-iOS物体识别使用说明
import SKEyeiOSSDKInitial from '../views/documents/skeyeios/SDKInitial'
// SKEye-iOS物体识别使用说明
import SKEyeiOScallImageInterface from '../views/documents/skeyeios/callImageInterface'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   SKEye-Android    **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKEye-Android物体识别使用说明
import SKEyeAndroidUserHelp from '../views/documents/skeyeandroid/SKEyeUserHelp'
// SKEye-Android SDK初始化
import SKEyeAndroidSDKInitial from '../views/documents/skeyeandroid/SDKInitial'
// SKEye-Android图像偏色处理
import SKEyeAndroidImageBias from '../views/documents/skeyeandroid/imageBias'
// SKEye-Android调用图像识别接口
import SKEyeAndroidCallImageInterface from '../views/documents/skeyeandroid/callImageInterface'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************    SKEye-Linux     **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKEye-Android物体识别使用说明
import SKEyeLinuxUserHelp from '../views/documents/skeyelinux/SKEyeUserHelp'
// SKEye-Android SDK初始化
import SKEyeLinuxSDKInitial from '../views/documents/skeyelinux/SDKInitial'
// SKEye-Android调用图像识别接口
import SKEyeLinuxCallImageInterface from '../views/documents/skeyelinux/callImageInterface'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                     **********************************************//
//************************************    SKEye-Windows    **********************************************//
//************************************                     **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKEye-Windows 物体识别使用说明
import SKEyeWinUserHelp from '../views/documents/skeyewindows/SKEyeUserHelp'
// SKEye-Windows SDK初始化
import SKEyeWinSDKInitial from '../views/documents/skeyewindows/SDKInitial'
// SKEye-Windows 调用图像识别接口
import SKEyeWinCallImageInterface from '../views/documents/skeyewindows/callImageInterface'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                     **********************************************//
//************************************     SKEye-Unity     **********************************************//
//************************************                     **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
// SKEye-Unity 物体识别使用说明
import SKEyeUnityUserHelp from '../views/documents/skeyeunity/SKEyeUserHelp'
// SKEye-Unity SDK初始化
import SKEyeUnitySDKInitial from '../views/documents/skeyeunity/SDKInitial'
// SKEye-Unity 调用图像识别接口
import SKEyeUnityCallImageInterface from '../views/documents/skeyeunity/callImageInterface'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                     **********************************************//
//************************************    SKObjects-API    **********************************************//
//************************************                     **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//SKObjects-API API使用说明
import SKObjectsUserHelp from '../views/documents/skobjectsapi/SKObjectsUserHelp'
//SKObjects-API API接口
import SKObjectsApi from '../views/documents/skobjectsapi/SKObjectsApi'
//*******************************************************************************************************//
//*******************************************************************************************************//
//************************************                    **********************************************//
//************************************   FRM账号登录       **********************************************//
//************************************                    **********************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//*******************************************************************************************************//
//---------------------------使用说明--------------------------------//
//使用说明
import FRMuserHelp from '../views/documents/FRMAPIVTOW/FRMuserHelp'
//----------------------------账号登录--------------------------------//
//账号登录 获取登录验证码
// import LoginAuthenticationCode from '../views/documents/FRMAPIVTOW/Accountlogin/LoginAuthenticationCode'
//账号登录 登录
import Signin from '../views/documents/FRMAPIVTOW/Accountlogin/Signin'
//----------------------------获取账号信息--------------------------------//
//获取账号信息 获取账号信息
import GettingAccountInformation from '../views/documents/FRMAPIVTOW/AccountSettings/GettingAccountInformation'
//----------------------------子账号管理--------------------------------//
//子账号管理 新建子账号
import NewSubaccount from '../views/documents/FRMAPIVTOW/Subaccountmanagement/NewSubaccount'
//子账号管理 获取子账号信息
import Getsubaccountinformation from '../views/documents/FRMAPIVTOW/Subaccountmanagement/Getsubaccountinformation'
//子账号管理 设置子账号信息
import Settingupsubaccountinformation from '../views/documents/FRMAPIVTOW/Subaccountmanagement/Settingupsubaccountinformation'
//子账号管理 删除子账号信息(暂无)
import Deletesubaccountinformation from '../views/documents/FRMAPIVTOW/Subaccountmanagement/Deletesubaccountinformation'
//子账号管理 获取子账号列表
import Getalistofsubaccounts from '../views/documents/FRMAPIVTOW/Subaccountmanagement/Getalistofsubaccounts'
//----------------------------项目管理--------------------------------//
//项目管理 新建项目
import Newproject from '../views/documents/FRMAPIVTOW/projectmanagement/Newproject'
//项目管理 设置项目属性
import Setupproject from '../views/documents/FRMAPIVTOW/projectmanagement/Setupproject'
//项目管理 设置项目属性
import GettingProjectInformation from '../views/documents/FRMAPIVTOW/projectmanagement/GettingProjectInformation'
//项目管理 删除项目
import deleteitem from '../views/documents/FRMAPIVTOW/projectmanagement/deleteitem'
//项目管理 获取项目列表
import Getalistofitems from '../views/documents/FRMAPIVTOW/projectmanagement/Getalistofitems'
//----------------------------人员管理--------------------------------//
//人员管理 新建人员
import Newstaff from '../views/documents/FRMAPIVTOW/Personnelmanagement/Newstaff'
//人员管理 获取人员信息
import Accesstopersonnelinformation from '../views/documents/FRMAPIVTOW/Personnelmanagement/Accesstopersonnelinformation'
//人员管理 设置人员信息
import setpersoninformation from '../views/documents/FRMAPIVTOW/Personnelmanagement/setpersoninformation'
//人员管理 移除人员
import Removepersonnel from '../views/documents/FRMAPIVTOW/Personnelmanagement/Removepersonnel'
//人员管理 移动人员
import Mobilepersonnel from '../views/documents/FRMAPIVTOW/Personnelmanagement/Mobilepersonnel'
//人员管理 复制人员
import Replicas from '../views/documents/FRMAPIVTOW/Personnelmanagement/Replicas'
//人员管理 获取人员组人员列表
import Personnellist from '../views/documents/FRMAPIVTOW/Personnelmanagement/Personnellist'
//人员管理 获取全部陌生人列表
// import GettingStrangers from '../views/documents/FRMAPIVTOW/Personnelmanagement/GettingStrangers'
//人员管理 新建人员组
import Newstaffgroup from '../views/documents/FRMAPIVTOW/Personnelmanagement/Newstaffgroup'
//人员管理 设置人员信息
import Settinguppersonnel from '../views/documents/FRMAPIVTOW/Personnelmanagement/Settinguppersonnel'
//人员管理 删除人员组
import Deletestaffgroups from '../views/documents/FRMAPIVTOW/Personnelmanagement/Deletestaffgroups'
//人员管理 复制人员组
import Replicatorgroup from '../views/documents/FRMAPIVTOW/Personnelmanagement/Replicatorgroup'
//人员管理 移动人员组
import MobilePersonnelGroup from '../views/documents/FRMAPIVTOW/Personnelmanagement/MobilePersonnelGroup'
//人员管理 获取人员组结构
import Gettingstaffstructure from '../views/documents/FRMAPIVTOW/Personnelmanagement/Gettingstaffstructure'
//人员管理 设置人员展示图片
import Settinguppersonneldisplaypictures from '../views/documents/FRMAPIVTOW/Personnelmanagement/Settinguppersonneldisplaypicturess'
//----------------------------终端登录--------------------------------//
//终端登录 获取终端信息
import GettingTerminalInformation from '../views/documents/FRMAPIVTOW/Terminalmanagement/GettingTerminalInformation'
//终端登录 设置终端信息
import SettingTerminalInformation from '../views/documents/FRMAPIVTOW/Terminalmanagement/SettingTerminalInformation'
//终端登录 移动终端
import mobileterminal from '../views/documents/FRMAPIVTOW/Terminalmanagement/mobileterminal'
//终端登录 移除终端
import Removeterminal from '../views/documents/FRMAPIVTOW/Terminalmanagement/Removeterminal'
//终端登录 新建终端组
import NewTerminalGroup from '../views/documents/FRMAPIVTOW/Terminalmanagement/NewTerminalGroup'
//终端登录 设置终端名称
import SettingTerminalName from '../views/documents/FRMAPIVTOW/Terminalmanagement/SettingTerminalName'
//终端登录 移动终端组
import Mobileterminalgroup from '../views/documents/FRMAPIVTOW/Terminalmanagement/Mobileterminalgroup'
//终端登录 移除终端组
import RemoveTerminalGroup from '../views/documents/FRMAPIVTOW/Terminalmanagement/RemoveTerminalGroup'
// 设置终端主题图】
import TgroupShowImage from '../views/documents/FRMAPIVTOW/Terminalmanagement/TgroupShowImage'
//终端登录 获取全部终端
import Acquisitionallterminals from '../views/documents/FRMAPIVTOW/Terminalmanagement/Acquisitionallterminals'
//终端登录 获取终端组结构
import Acquisitionterminalstructure from '../views/documents/FRMAPIVTOW/Terminalmanagement/Acquisitionterminalstructure'
//终端登录 设置终端组的可识别人员组
import Settingidentifiablegroupspeople from '../views/documents/FRMAPIVTOW/Terminalmanagement/Settingidentifiablegroupspeople'
//终端登录 生成终端组绑定码
import GeneratingBindingCode from '../views/documents/FRMAPIVTOW/Terminalmanagement/GeneratingBindingCode'
//终端登录 获取终端组可识别人员组
import Obtainidentifiablegroupspeople from '../views/documents/FRMAPIVTOW/Terminalmanagement/Obtainidentifiablegroupspeople'
//----------------------------人脸识别--------------------------------//
//人脸识别 人脸检测
import Facedetection from '../views/documents/FRMAPIVTOW/Facerecognition/Facedetection'

//人脸识别 1.1特征提取
import FeatureExtract from '../views/documents/FRMAPIVTOW/Facerecognition/Feature_extract'
//人脸识别 人脸对比
import Facecomparison from '../views/documents/FRMAPIVTOW/Facerecognition/Facecomparison'
//----------------------------统计信息--------------------------------//
//人脸识别 获取人员/人员组的识别记录
import identificationrecords from '../views/documents/FRMAPIVTOW/statisticalinformation/identificationrecords'
//人脸识别 获取终端/终端组的识别记录
import ObtainingGroups from '../views/documents/FRMAPIVTOW/statisticalinformation/ObtainingGroups'
import AccountRecord from '../views/documents/FRMAPIVTOW/statisticalinformation/AccountRecord'


//----------------------------消息推送--------------------------------//
//人脸识别 消息推送
import messagePpush from '../views/documents/FRMAPIVTOW/Messagepush/messagePush'
//----------------------------状态码--------------------------------//
//状态码
import StatusCode from '../views/documents/FRMAPIVTOW/StatusCode/StatusCode'


Vue.use(VueRouter)
const routes = [
	{
	    path: '/',
	    name: 'homepage',
	    component: HomePage,
	    //首页跳转至文档中心页
	    redirect: '/dochomepage',
	    children:[
	    	{
		      	path: '/dochomepage',
		      	name: 'dochomepage',
		      	meta:{type:'document'},
		      	component: DocHomePage,
		    },
	    	{
		      	path: '/documentindex',
		      	name: 'documentindex',
		      	meta:{type:'document'},
		      	component: DocumentIndex,
		      	children:[
					  
		      		{//API接入流程
		      			path: '/apiaccess',
				      	name: 'apiaccess',
				      	meta:{type:'document'},
				      	component: ApiAccess
		      		},
		      		{//用户鉴权服务方案
		      			path: '/Authorization',
				      	name: 'Authorization',
				      	meta:{type:'document'},
				      	component: UserService
		      		},
					//**********************************************************************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//*******************          FRM                   *******************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//**********************************************************************//
					//---------------使用说明---------------//
					{//使用说明
		      			path: '/skfrm-userhelp',
				      	name: 'skfrm-userhelp',
				      	meta:{type:'document'},
				      	component: FRMuserHelp
		      		},
					//---------------账号登录---------------//
					// {//获取登录验证码
		      		// 	path: '/skfrm-verificationcode',
				    //   	name: 'skfrm-verificationcode',
				    //   	meta:{type:'document'},
				    //   	component: LoginAuthenticationCode
		      		// },
					{//登录
		      			path: '/skfrm-login',
				      	name: 'skfrm-login',
				      	meta:{type:'document'},
				      	component: Signin
		      		},
					//---------------获取账号信息---------------//
					{//获取账号信息
		      			path: '/skfrm-account_info',
				      	name: 'skfrm-account_info',
				      	meta:{type:'document'},
				      	component: GettingAccountInformation
		      		},
					//---------------子账号管理---------------//
					{//新建子账号
		      			path: '/skfrm-subaccount_add',
				      	name: 'skfrm-subaccount_add',
				      	meta:{type:'document'},
				      	component: NewSubaccount
		      		},
					{//获取子账号信息
		      			path: '/skfrm-subaccount_info',
				      	name: 'skfrm-subaccount_info',
				      	meta:{type:'document'},
				      	component: Getsubaccountinformation
		      		},
					{//设置子账号信息
		      			path: '/skfrm-subaccount_set',
				      	name: 'skfrm-subaccount_set',
				      	meta:{type:'document'},
				      	component: Settingupsubaccountinformation
		      		},
					{//删除子账号信息
		      			path: '/sk-frm-deletesubaccountinformation',
				      	name: 'sk-frm-deletesubaccountinformation',
				      	meta:{type:'document'},
				      	component: Deletesubaccountinformation
		      		},
					{//获取子账号列表
		      			path: '/skfrm-subaccount_list',
				      	name: 'skfrm-subaccount_list',
				      	meta:{type:'document'},
				      	component: Getalistofsubaccounts
		      		},
					{//新建项目
		      			path: '/skfrm-project_add',
				      	name: 'skfrm-project_add',
				      	meta:{type:'document'},
				      	component: Newproject
		      		},
					{//设置项目属性
		      			path: '/skfrm-project_set',
				      	name: 'skfrm-project_set',
				      	meta:{type:'document'},
				      	component: Setupproject
		      		},
					{//获取项目信息
		      			path: '/skfrm-project_info',
				      	name: 'skfrm-project_info',
				      	meta:{type:'document'},
				      	component: GettingProjectInformation
		      		},
					{//删除项目
		      			path: '/sk-frm-deleteitem',
				      	name: 'sk-frm-deleteitem',
				      	meta:{type:'document'},
				      	component: deleteitem
		      		},
					{//获取项目列表
		      			path: '/skfrm-project_list',
				      	name: 'skfrm-project_list',
				      	meta:{type:'document'},
				      	component: Getalistofitems
		      		},
					//---------------人员管理---------------//
					{//新建人员
		      			path: '/skfrm-person_add',
				      	name: 'skfrm-person_add',
				      	meta:{type:'document'},
				      	component: Newstaff
		      		},
					{//获取人员信息
		      			path: '/skfrm-person_info',
				      	name: 'skfrm-person_info',
				      	meta:{type:'document'},
				      	component: Accesstopersonnelinformation
		      		},
					{//设置人员信息
		      			path: '/skfrm-set_person_info',
				      	name: 'skfrm-set_person_info',
				      	meta:{type:'document'},
				      	component: setpersoninformation
		      		},
					{//移除人员
		      			path: '/skfrm-person_del',
				      	name: 'skfrm-person_del',
				      	meta:{type:'document'},
				      	component: Removepersonnel
		      		},
					{//移动人员
		      			path: '/skfrm-person_movel',
				      	name: 'skfrm-person_movel',
				      	meta:{type:'document'},
				      	component: Mobilepersonnel
		      		},
					{//复制人员
		      			path: '/skfrm-person_copy',
				      	name: 'skfrm-person_copy',
				      	meta:{type:'document'},
				      	component: Replicas
		      		},
					{//获取人员组人员列表
		      			path: '/skfrm-person_list',
				      	name: 'skfrm-person_list',
				      	meta:{type:'document'},
				      	component: Personnellist
		      		},
					{//设置人员展示图片
		      			path: '/skfrm-person_show_image',
				      	name: 'skfrm-person_show_image',
				      	meta:{type:'document'},
				      	component: Settinguppersonneldisplaypictures
		      		},
					// {//获取全部陌生人列表
		      		// 	path: '/sk-frm-GettingStrangers',
				    //   	name: 'sk-frm-GettingStrangers',
				    //   	meta:{type:'document'},
				    //   	component: GettingStrangers
		      		// },
					{//新建人员组
		      			path: '/skfrm-pgroup_add',
				      	name: 'skfrm-pgroup_add',
				      	meta:{type:'document'},
				      	component: Newstaffgroup
		      		},
					{//设置人员信息
		      			path: '/skfrm-pgroup_set',
				      	name: 'skfrm-pgroup_set',
				      	meta:{type:'document'},
				      	component: Settinguppersonnel
		      		},
					{//删除人员组
		      			path: '/skfrm-pgroup_del',
				      	name: 'skfrm-pgroup_del',
				      	meta:{type:'document'},
				      	component: Deletestaffgroups
		      		},
					{//复制人员组
		      			path: '/skfrm-pgroup_copy',
				      	name: 'skfrm-pgroup_copy',
				      	meta:{type:'document'},
				      	component: Replicatorgroup
		      		},
					{//移动人员组
		      			path: '/skfrm-pgroup_move',
				      	name: 'skfrm-pgroup_move',
				      	meta:{type:'document'},
				      	component: MobilePersonnelGroup
		      		},
					{//获取人员组结构
		      			path: '/skfrm-get_pgroup_hierarchy',
				      	name: 'skfrm-get_pgroup_hierarchy',
				      	meta:{type:'document'},
				      	component: Gettingstaffstructure
		      		},
					//---------------终端管理---------------//
					{//获取终端信息
		      			path: '/skfrm-terminal_info',
				      	name: 'skfrm-terminal_info',
				      	meta:{type:'document'},
				      	component: GettingTerminalInformation
		      		},
					{//设置终端信息
		      			path: '/skfrm-terminal_set',
				      	name: 'skfrm-terminal_set',
				      	meta:{type:'document'},
				      	component: SettingTerminalInformation
		      		},
					{//移动终端
		      			path: '/skfrm-terminal_move',
				      	name: 'skfrm-terminal_move',
				      	meta:{type:'document'},
				      	component: mobileterminal
		      		},
					{//移除终端
		      			path: '/skfrm-terminal_del',
				      	name: 'skfrm-terminal_del',
				      	meta:{type:'document'},
				      	component: Removeterminal
		      		},
					{//新建终端组
		      			path: '/skfrm-tgroup_add',
				      	name: 'skfrm-tgroup_add',
				      	meta:{type:'document'},
				      	component: NewTerminalGroup
		      		},
					{//设置终端名称
		      			path: '/skfrm-tgroup_set',
				      	name: 'skfrm-tgroup_set',
				      	meta:{type:'document'},
				      	component: SettingTerminalName
		      		},
					{//移动终端组
		      			path: '/skfrm-tgroup_move',
				      	name: 'skfrm-tgroup_move',
				      	meta:{type:'document'},
				      	component: Mobileterminalgroup
		      		},
					{//移除终端组
		      			path: '/skfrm-tgroup_del',
				      	name: 'skfrm-tgroup_del',
				      	meta:{type:'document'},
				      	component: RemoveTerminalGroup
		      		},
					  {//设置终端展示图片
		      			path: '/skfrm-tgroup_show_image',
				      	name: 'skfrm-tgroup_show_image',
				      	meta:{type:'document'},
				      	component: TgroupShowImage
		      		},
					{//获取全部终端
		      			path: '/skfrm-terminal_list',
				      	name: 'skfrm-terminal_list',
				      	meta:{type:'document'},
				      	component: Acquisitionallterminals
		      		},
					{//获取终端组结构
		      			path: '/skfrm-get_tgroup_hierarchy',
				      	name: 'skfrm-get_tgroup_hierarchy',
				      	meta:{type:'document'},
				      	component: Acquisitionterminalstructure
		      		},
					{//设置终端组的可识别人员组
		      			path: '/skfrm-person2terminal',
				      	name: 'skfrm-person2terminal',
				      	meta:{type:'document'},
				      	component: Settingidentifiablegroupspeople
		      		},
					{//生成终端组绑定码
		      			path: '/skfrm-terminal_binding_code',
				      	name: 'skfrm-terminal_binding_code',
				      	meta:{type:'document'},
				      	component: GeneratingBindingCode
		      		},
					{//获取终端组可识别人员组
		      			path: '/skfrm-person2terminal_info',
				      	name: 'skfrm-person2terminal_info',
				      	meta:{type:'document'},
				      	component: Obtainidentifiablegroupspeople
		      		},
					//---------------人脸识别---------------//
					{//人脸检测
		      			path: '/skfrm-face_detect',
				      	name: 'skfrm-face_detect',
				      	meta:{type:'document'},
				      	component: Facedetection
		      		},
					{//人脸检测
		      			path: '/skfrm-feature_extract',
				      	name: 'skfrm-feature_extract',
				      	meta:{type:'document'},
				      	component: FeatureExtract
		      		},
					{//人脸对比
		      			path: '/skfrm-face_compare',
				      	name: 'skfrm-face_compare',
				      	meta:{type:'document'},
				      	component: Facecomparison
		      		},
					//---------------统计信息---------------//
					{//获取人员/人员组的识别记录
		      			path: '/skfrm-person_record',
				      	name: 'skfrm-person_record',
				      	meta:{type:'document'},
				      	component: identificationrecords
		      		},
					{//获取终端/终端组的识别记录
		      			path: '/skfrm-terminal_record',
				      	name: 'skfrm-terminal_record',
				      	meta:{type:'document'},
				      	component: ObtainingGroups
					  },
					{//获取账号下的识别记录
						path: '/skfrm-account_record',
						name: 'skfrm-account_record',
						meta:{type:'document'},
						component: AccountRecord
					},
					//---------------消息推送---------------//
					{//消息推送
		      			path: '/skfrm-message_push',
				      	name: 'skfrm-message_push',
				      	meta:{type:'document'},
				      	component: messagePpush
					},
					{//状态码
						path: '/skfrm-status_code',
						name: 'skfrm-status_code',
						meta:{type:'document'},
						component: StatusCode
					},  
					  
		      		//**********************************************************************//
		      		//**********************************************************************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//*******************           SKFace-IOS           *******************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//*******************                                *******************//
		      		//**********************************************************************//
		      		//---------------基础接口---------------//
		      		{//iOS人脸识别 使用说明
		      			path: '/skface-ios-userhelp',
				      	name: 'skface-userhelp',
				      	meta:{type:'document'},
				      	component: SkfaceiosHelp
		      		},
		      		{//iOS人脸识别 SDK初始化
		      			path: '/skface-ios-init',
				      	name: 'skface-ios-init',
				      	meta:{type:'document'},
				      	component: SDKInitial
		      		},
		      		{//iOS人脸识别 释放SDK资源
		      			path: '/skface-ios-release',
				      	name: 'skface-ios-release',
				      	meta:{type:'document'},
				      	component: ReleaseSDK
		      		},
		      		{//iOS人脸识别 视频人脸检测与跟踪初始化
		      			path: '/skface-ios-trackinit',
				      	name: 'skface-ios-trackinit',
				      	meta:{type:'document'},
				      	component: FaceInitial
		      		},
		      		{//iOS人脸识别 视频人脸检测与跟踪
		      			path: '/skface-ios-track',
				      	name: 'skface-ios-track',
				      	meta:{type:'document'},
				      	component: FaceTrack
		      		},
		      		{//iOS人脸识别 设置人脸识别阈值
		      			path: '/skface-ios-setthreshold',
				      	name: 'skface-ios-setthreshold',
				      	meta:{type:'document'},
				      	component: SetFace
		      		},
		      		{//iOS人脸识别 获取人脸识别阈值
		      			path: '/skface-ios-getthreshold',
				      	name: 'skface-ios-getthreshold',
				      	meta:{type:'document'},
				      	component: GetFace
		      		},
		      		//---------------本地人脸管理接口---------------//
		      		{//iOS人脸识别 开启人脸注册
		      			path: '/skface-ios-startregperson',
				      	name: 'skface-ios-startregperson',
				      	meta:{type:'document'},
				      	component: OpenFaceRegister
		      		},
		      		{//iOS人脸识别 停止人脸注册
		      			path: '/skface-ios-cancelregperson',
				      	name: 'skface-ios-cancelregperson',
				      	meta:{type:'document'},
				      	component: StopFaceRegister
		      		},
		      		{//iOS人脸识别 删除人员信息
		      			path: '/skface-ios-deleteperson',
				      	name: 'skface-ios-deleteperson',
				      	meta:{type:'document'},
				      	component: DeletePerson
		      		},
		      		{//iOS人脸识别 设置人脸属性
		      			path: '/skface-ios-setperson',
				      	name: 'skface-ios-setperson',
				      	meta:{type:'document'},
				      	component: SetFaceAttribute
		      		},
		      		{//iOS人脸识别 设置识别记录的缓存上限
		      			path: '/skface-ios-setuploadbuffer',
				      	name: 'skface-ios-setuploadbuffer',
				      	meta:{type:'document'},
				      	component: SetUpperLimit
		      		},
		      		{//iOS人脸识别 获取认识的人员数量及列表
		      			path: '/skface-ios-getpersondata',
				      	name: 'skface-ios-getpersondata',
				      	meta:{type:'document'},
				      	component: GetPersonList
		      		},
		      		{//iOS人脸识别 获取认识人员的详细信息
		      			path: '/skface-ios-getpersoninfo',
				      	name: 'skface-ios-getpersoninfo',
				      	meta:{type:'document'},
				      	component: GetPersonDetails
		      		},
		      		//---------------事件接口---------------//
		      		{//iOS人脸识别 设置事件监听
		      			path: '/skface-ios-setevent',
				      	name: 'skface-ios-setevent',
				      	meta:{type:'document'},
				      	component: SetEventMonitor
		      		},
		      		{//iOS人脸识别 短时记忆功能
		      			path: '/skface-ios-shortmemory',
				      	name: 'skface-ios-shortmemory',
				      	meta:{type:'document'},
				      	component: ShortTimeMemory
		      		},
		      		//---------------FRM相关接口---------------//
		      		{//iOS人脸识别 提取FRM绑定码信息
		      			path: '/skface-ios-getbindinfowithcode',
				      	name: 'skface-ios-getbindinfowithcode',
				      	meta:{type:'document'},
				      	component: GetFRMBindCode
		      		},
		      		{//iOS人脸识别 绑定FRM
		      			path: '/skface-ios-bindfrm',
				      	name: 'skface-ios-bindfrm',
				      	meta:{type:'document'},
				      	component: BindFRM
		      		},
		      		{//iOS人脸识别 解绑FRM
		      			path: '/skface-ios-unbindfrm',
				      	name: 'skface-ios-unbindfrm',
				      	meta:{type:'document'},
				      	component: UntyingFRM
		      		},
		      		{//iOS人脸识别 获取本机当前绑定信息
		      			path: '/skface-ios-getdevicebindinfo',
				      	name: 'skface-ios-getdevicebindinfo',
				      	meta:{type:'document'},
				      	component: GetBindInformation
		      		},
		      		{//iOS人脸识别 获取当前终端所拥有的人员分组结构
		      			path: '/skface-ios-getdevicepersonstructure',
				      	name: 'skface-ios-getdevicepersonstructure',
				      	meta:{type:'document'},
				      	component: GetDeviceAllGroup
		      		},
		      		{//iOS人脸识别 获取FRM终端名称
		      			path: '/skface-ios-getdevicename',
				      	name: 'skface-ios-getdevicename',
				      	meta:{type:'document'},
				      	component: GetFRMDeviceName
		      		},
		      		{//iOS人脸识别 通过人员组ID获得人员组路径信息
		      			path: '/skface-ios-grouppath',
				      	name: 'skface-ios-grouppath',
				      	meta:{type:'document'},
				      	component: GetPath
		      		},
		      		{//iOS人脸识别 人员本地ID转换为云端对应ID
		      			path: '/skface-ios-personlocalidserverid',
				      	name: 'skface-ios-personlocalidserverid',
				      	meta:{type:'document'},
				      	component: TransformationID
		      		},
		      		//---------------图片处理相关接口---------------//
		      		{//iOS人脸识别 图片人脸检测与分析
		      			path: '/skface-ios-imagedetect',
				      	name: 'skface-ios-imagedetect',
				      	meta:{type:'document'},
				      	component: FaceTesting
		      		},
		      		{//iOS人脸识别 人脸特征对比
		      			path: '/skface-ios-facefeaturecompare',
				      	name: 'skface-ios-facefeaturecompare',
				      	meta:{type:'document'},
				      	component: FaceContrast
		      		},
		      		//---------------SDK版本信息接口---------------//
		      		{//iOS人脸识别 获取SDK版本号
		      			path: '/skface-ios-getsdkversion',
				      	name: 'skface-ios-getsdkversion',
				      	meta:{type:'document'},
				      	component: GetSDKVersion
		      		},
		      		{//iOS人脸识别 获取人脸识别内核版本号
		      			path: '/skface-ios-getkernelversion',
				      	name: 'skface-ios-getkernelversion',
				      	meta:{type:'document'},
				      	component: GetFaceKernel
		      		},{//iOS人脸识别 获得Model版本号
		      			path: '/skface-ios-getmodelversion',
				      	name: 'skface-ios-getmodelversion',
				      	meta:{type:'document'},
				      	component: GetModeVersion
		      		},
					//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                         ******************//
		      		//*******************          SKFaceSDKFamily接口说明        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
					//---------------基础接口---------------//
					{//使用说明
						path: '/skface-family-android-userhelp',
				      	name: 'skface-family--android-userhelp',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyHelp
					},
						{//使用说明
						path: '/skface-family-android-init',
				      	name: 'skface-family-android-init',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyInitial
					},
						{//使用说明
						path: '/skface-family-android-getsdkversion',
				      	name: 'skface-family-android-getsdkversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyeVersion
					},
						{//使用说明
						path: '/skface-family-android-getkernelversion',
				      	name: 'skface-family-android-getkernelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyKernel
					},
						{//使用说明
						path: '/skface-family-android-getmodelversion',
				      	name: 'skface-family-android-getmodelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyModel
					},
						{//使用说明
						path: '/skface-family-android-releasesdk',
				      	name: 'skface-family-android-releasesdk',
				      	meta:{type:'document'},
				      	component: SKFaceSDKFamilyReleaseSDK
					},
						{//使用说明
						path: '/skface-family-android-imagedetect',
				      	name: 'skface-family-android-imagedetect',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyFcetest
					},
							{//使用说明
						path: '/skface-family-android-featurecompare',
				      	name: 'skface-family-android-featurecompare',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyFceContrast 
					},
						{//视频初始化	
						path: '/skface-family-android-videotrackinit',
				      	name: 'skface-family-android-videotrackinit',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideinitiali
					},
					{//设置“陌生人短时记忆功能”打开、关闭	
						path: '/skface-family-android-memory',
				      	name: 'skface-family-android-memory',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideStranger
					},
					{//Video版人脸检测与跟踪	
						path: '/skface-family-android-videotrack',
				      	name: 'skface-family-android-videotrack',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideDetection
					},
					{//获取FRM绑定信息	
						path: '/skface-family-android-bindfrminfo',
				      	name: 'skface-family-android-bindfrminfo',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideFrm
					},
					{//获取本机当前绑定信息	
						path: '/skface-family-android-getdevicebindinfo',
				      	name: 'skface-family-android-getdevicebindinfo',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideLocal
					},
					{//绑定FRM	
						path: '/skface-family-android-bindfrm',
				      	name: 'skface-family-android-bindfrm',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideBindingfrm
					},
					{//解绑FRM	
						path: '/skface-family-android-unbindfrm',
				      	name: 'skface-family-android-unbindfrm',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideUntying
					},
					{//设置事件监听	
						path: '/skface-family-android-registerevent',
				      	name: 'skface-family-android-registerevent',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideSeetingmonitor
					},
					{//开始人脸注册	
						path: '/skface-family-android-startregperson',
				      	name: 'skface-family-android-startregperson',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideFaceregister
					},
					{//取消人脸注册	
						path: '/skface-family-android-stopregperson',
				      	name: 'skface-family-android-stopregperson',
				      	meta:{type:'document'},
				      	component:  SkfaceSDKFamilyVoideCancelfaceregister
					},	
					{//获取人的详细信息	
						path: '/skface-family-android-getpersoninfo',
				      	name: 'skface-family-android-getpersoninfo',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideGetpeople
					},
					{//设置名字	
						path: '/skface-family-android-setpersonname',
				      	name: 'skface-family-android-setpersonname',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoidePeoplename
					},
					{//设置性别
						path: '/skface-family-android-setpersonsex',
				      	name: 'skface-family-android-setpersonsex',
				      	meta:{type:'document'},
				      	component:SkfaceSDKFamilyVoideSex
					},
					{//设置生日	
						path: '/skface-family-android-setpersonbirthday',
				      	name: 'skface-family-android-setpersonbirthday',
				      	meta:{type:'document'},
				      	component:SkfaceSDKFamilyVoideBrithday
					},
					{//设置细节（其他属性信息）	
						path: '/skface-family-android-setpersondetails',
				      	name: 'skface-family-android-setpersondetails',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideDetails
					},
					{//删除一个人（全部信息）	
						path: '/skface-family-android-delperson',
				      	name: 'skface-family-android-delperson',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoidedeLetepeople
					},
					{//获取当前设备所关联人员库Person数量	
						path: '/skface-family-android-getpersondatabasenum',
				      	name: 'skface-family-android-getpersondatabasenum',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideGetperson
					},
					{//获取认识的人列表	
						path: '/skface-family-android-getpersonlist',
				      	name: 'skface-family-android-getpersonlist',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoidePeopleselect
					},
					{//获取设备名称（FRM终端名称）	
						path: '/skface-family-android-getdevicename',
				      	name: 'skface-family-android-getdevicename',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideSetequipment
					},
					{//获取当前设备所拥有的人员分组结构	
						path: '/skface-family-android-getdevicepersonstructure',
				      	name: 'skface-family-android-getdevicepersonstructure',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideGrouping
					},
					{//人员本地ID转换为云端对应ID
						path: '/skface-family-android-personlocalidServerid',
				      	name: 'skface-family-android-personlocalidServerid',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideTransformation
					},
					{//设置人脸识别阈值	
						path: '/skface-family-android-setfacethreshold',
				      	name: 'skface-family-android-setfacethreshold',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideThreshold
					},
					{//人员的组ID转换为人员所在组的路径
						path: '/skface-family-android-grouppath',
				      	name: 'skface-family-android-grouppath',
				      	meta:{type:'document'},
				      	component: SkfaceSDKFamilyVoideRouter
					},				
					//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************           SKFaceSDKLite接口说明         *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
					//---------------基础接口---------------//
					{//使用说明
						path: '/skface-lite-android-userhelp',
				      	name: 'skface-lite-android-userhelp',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteHelp
					},
					{//SDK初始化
						path: '/skface-lite-android-init',
				      	name: 'skface-lite-android-init',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteInitial
					},
					{//释放SDK资源
						path: '/skface-lite-android-releasesDK',
				      	name: 'skface-lite-android-releasesDK',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteVersion
					},
					{//视频人脸识别与跟踪初始化
						path: '/skface-lite-android-videotrackinit',
				      	name: 'skface-lite-android-videotrackinit',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteDistinguishTrack
					},
					{//视频人脸检测与跟踪
						path: '/skface-lite-android-videotrack',
				      	name: 'skface-lite-android-videotrack',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteTrack
					},
					{//获取SDK版本号
						path: '/skface-lite-android-getsdkversion',
				      	name: 'skface-lite-android-getsdkversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteEdition
					},
					{//获得人脸识别内核版本号
						path: '/skface-lite-android-getkernelversion',
				      	name: 'skface-lite-android-getkernelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteKernel
					},
					{//获得Model版本号
						path: '/skface-lite-android-getmodelversion',
				      	name: 'skface-lite-android-getmodelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiteModel
					},
					//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************           SKFaceSDKLive接口说明         *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
					//---------------基础接口---------------//
					{//使用说明
						path: '/skface-live-android-userhelp',
				      	name: 'skface-live-android-userhelp',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveHelp
					},
					{//SDK初始化
						path: '/skface-live-android-init',
				      	name: 'skface-live-android-init',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveInitial
					},
					{//获取SDK版本号
						path: '/skface-live-android-getsdkversion',
				      	name: 'skface-live-android-getsdkversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveVersion
					},
					{//获得人脸识别内核版本号
						path: '/skface-live-android-getkernelversion',
				      	name: 'skface-live-android-getkernelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveKernel
					},
					{//获得Model版本号
						path: '/skface-live-android-getmodelversion',
				      	name: 'skface-live-android-getmodelversion',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveModel
					},
					{//释放SDK资源
						path: '/skface-live-android-releasesdk',
				      	name: 'skface-live-android-releasesdk',
				      	meta:{type:'document'},
				      	component: SKFaceSDKLiveReleaseSDK
					},
					{//Image版人脸检测
						path: '/skface-live-android-imagedetect',
				      	name: 'skface-live-android-imagedetect',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveFcetest
					},
					{//人脸特征比对	
						path: '/skface-live-android-featurecompare',
				      	name: 'skface-live-android-featurecompare',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveFceContrast
					},
					
					{//视频初始化	
						path: '/skface-live-android-videotrackinit',
				      	name: 'skface-live-android-videotrackinit',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideinitiali
					},
					{//设置“陌生人短时记忆功能”打开、关闭	
						path: '/skface-live-android-memory',
				      	name: 'skface-live-android-memory',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideStranger
					},
					{//Video版人脸检测与跟踪	
						path: '/skface-live-android-videotrack',
				      	name: 'skface-live-android-videotrack',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideDetection
					},
					{//活体检测	
						path: '/skface-live-android-livedetect',
				      	name: 'skface-live-android-livedetect',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideLiving
					},
					{//人证对比
						path: '/skface-live-android-withfeature',
				      	name: 'skface-live-android-withfeature',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideWitness
					},
					{//获取FRM绑定信息	
						path: '/skface-live-android-bindfrminfo',
				      	name: 'skface-live-android-bindfrminfo',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideFrm
					},
					{//获取本机当前绑定信息	
						path: '/skface-live-android-getdevicebindinfo',
				      	name: 'skface-live-android-getdevicebindinfo',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideLocal
					},
					{//绑定FRM	
						path: '/skface-live-android-bindfrm',
				      	name: 'skface-live-android-bindfrm',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideBindingfrm
					},
					{//解绑FRM	
						path: '/skface-live-android-unbindfrm',
				      	name: 'skface-live-android-unbindfrm',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideUntying
					},
					{//设置事件监听	
						path: '/skface-live-android-registerevent',
				      	name: 'skface-live-android-registerevent',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideSeetingmonitor
					},
					{//开始人脸注册	
						path: '/skface-live-android-startregperson',
				      	name: 'skface-live-android-startregperson',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideFaceregister
					},
					{//取消人脸注册	
						path: '/skface-live-android-stopregperson',
				      	name: 'skface-live-android-stopregperson',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideCancelfaceregister
					},					
					{//获取人的详细信息	
						path: '/skface-live-android-getpersoninfo',
				      	name: 'skface-live-android-getpersoninfo',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideGetpeople
					},
					{//设置名字	
						path: '/skface-live-android-setpersonname',
				      	name: 'skface-live-android-setpersonname',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoidePeoplename
					},
					{//设置性别
						path: '/skface-live-android-setpersonsex',
				      	name: 'skface-live-android-setpersonsex',
				      	meta:{type:'document'},
				      	component:SkfaceSDKLiveVoideSex
					},
					{//设置生日	
						path: '/skface-live-android-setpersonbirthday',
				      	name: 'skface-live-android-setpersonbirthday',
				      	meta:{type:'document'},
				      	component:SkfaceSDKLiveVoideBrithday
					},
					{//设置细节（其他属性信息）	
						path: '/skface-live-android-setpersondetailsinfo',
				      	name: 'skface-live-android-setpersondetailsinfo',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideDetails
					},
					{//删除一个人（全部信息）	
						path: '/skface-live-android-delperson',
				      	name: 'skface-live-android-delperson',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoidedeLetepeople
					},
					{//获取当前设备所关联人员库Person数量	
						path: '/skface-live-android-getPersondatabasenum',
				      	name: 'skface-live-android-getPersondatabasenum',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideGetperson
					},
					{//获取认识的人列表	
						path: '/skface-live-android-getpersonlist',
				      	name: 'skface-live-android-getpersonlist',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoidePeopleselect
					},
					{//获取设备名称（FRM终端名称）	
						path: '/skface-live-android-getdevicename',
				      	name: 'skface-live-android-getdevicename',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideSetequipment
					},
					{//获取当前设备所拥有的人员分组结构	
						path: '/skface-live-android-getdeviceperson',
				      	name: 'skface-live-android-getdeviceperson',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideGrouping
					},
					{//人员本地ID转换为云端对应ID
						path: '/skface-live-android-personlocalddserverid',
				      	name: 'skface-live-android-personlocalddserverid',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideTransformation
					},
					{//设置人脸识别阈值	
						path: '/skface-live-android-setfacethreshold',
				      	name: 'skface-live-android-setfacethreshold',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideThreshold
					},
					{//人员的组ID转换为人员所在组的路径
						path: '/skface-live-android-grouppath',
				      	name: 'skface-live-android-grouppath',
				      	meta:{type:'document'},
				      	component: SkfaceSDKLiveVoideRouter
					},
					//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************           SKFaceSDK-Android            *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------基础接口---------------//
					{//使用说明
						path: '/skface-android-userhelp',
				      	name: 'skface-android-userhelp',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidHelp
					},
					{//SDK初始化与释放
		      			path: '/skface-android-skfaceinit',
				      	name: 'skface-android-skfaceinit',
				      	meta:{type:'document'},
				      	component: SkfaceSdkInitializationRelease
		      		},
					{//视频人脸检测与识别
		      			path: '/skface-android-videotrackinit',
				      	name: 'skface-android-videotrackinit',
				      	meta:{type:'document'},
				      	component: SkfaceSdkVideoDetectionRecognition
		      		},
					{//设置和获取人脸识别阈值
		      			path: '/skface-android-threshold',
				      	name: 'skface-android-threshold',
				      	meta:{type:'document'},
				      	component: SkfaceSdkethreshold
		      		},
					{//人脸记忆功能
		      			path: '/skface-android-memory',
				      	name: 'skface-android-memory',
				      	meta:{type:'document'},
				      	component: SkfaceSdkFacememory
		      		},
					{//清除缓存
		      			path: '/skface-android-detectbuffer',
				      	name: 'skface-android-detectbuffer',
				      	meta:{type:'document'},
				      	component: SkfaceSdkClearcache
		      		},
					{//获取终端ID
		      			path: '/skface-android-getdeviceuniqueid',
				      	name: 'skface-android-getdeviceuniqueid',
				      	meta:{type:'document'},
				      	component: SkfaceSdkGetterminalID
		      		},
					{//设置图像数据格式
		      			path: '/skface-android-setyuvformat',
				      	name: 'skface-android-setyuvformat',
				      	meta:{type:'document'},
				      	component: SkfaceSdkSettingImageFormat
		      		},
					{//开启与停止人脸注册
		      			path: '/skface-android-startregperson',
				      	name: 'skface-android-startregperson',
				      	meta:{type:'document'},
				      	component: SkfaceSdkOpenandStop
		      		},
					{//删除人员信息
		      			path: '/skface-android-delperson',
				      	name: 'skface-android-delperson',
				      	meta:{type:'document'},
				      	component: SkfaceSdkDeletepersonnel
		      		},
					{//设置人脸属性
		      			path: '/skface-android-setperson',
				      	name: 'skface-android-setperson',
				      	meta:{type:'document'},
				      	component: SkfaceSdkSettingFaceProperties
		      		},
					{//获取本地人员识别信息
		      			path: '/skface-android-getperson',
				      	name: 'skface-android-getperson',
				      	meta:{type:'document'},
				      	component: SkfaceSdkLocalPersonnel
		      		},
					{//设置识别记录的缓存上限
		      			path: '/skface-android-setuploadbuffer',
				      	name: 'skface-android-setuploadbuffer',
				      	meta:{type:'document'},
				      	component: SkfaceSdkRecordcache
		      		},
					{//设置事件监听
		      			path: '/skface-android-registerevent',
				      	name: 'skface-android-registerevent',
				      	meta:{type:'document'},
				      	component: SkfaceSdkSettingeventmonitoring
		      		},
					{//绑定/解绑FRM
		      			path: '/skface-android-bindfrminfo',
				      	name: 'skface-android-bindfrminfo',
				      	meta:{type:'document'},
				      	component: SkfaceSdkUnbound
		      		},
					{//获取FRM终端名称
		      			path: '/skface-android-getdevicename',
				      	name: 'skface-android-getdevicename',
				      	meta:{type:'document'},
				      	component: SkfaceSdkGettingfrmterminals
		      		},
					{//获取人员组的路径信息
		      			path: '/skface-android-grouppath',
				      	name: 'skface-android-grouppath',
				      	meta:{type:'document'},
				      	component: SkfaceSdkPersonnelgrouppath
		      		},
					{//本地人员ID的云端同步
		      			path: '/skface-android-personlocalidserverid',
				      	name: 'skface-android-personlocalidserverid',
				      	meta:{type:'document'},
				      	component: SkfaceSdkLocalstaff
		      		},
					{//获取终端人员组织架构信息
		      			path: '/skface-android-getdevicepersonstructure',
				      	name: 'skface-android-getdevicepersonstructure',
				      	meta:{type:'document'},
				      	component: SkfaceSdkOrganizationalArchitecture
		      		},
					{//图片人脸检测与分析
		      			path: '/skface-android-imagedetect',
				      	name: 'skface-android-imagedetect',
				      	meta:{type:'document'},
				      	component: SkfaceSdkimgFaceDetection
		      		},
					{//人脸特征比对
		      			path: '/skface-android-featurecompare',
				      	name: 'skface-android-featurecompare',
				      	meta:{type:'document'},
				      	component: SkfaceSdkFeaturecomparison
		      		},
					{//获取SDK版本号
		      			path: '/skface-android-getsdkversion',
				      	name: 'skface-android-getsdkversion',
				      	meta:{type:'document'},
				      	component: SkfaceSdkGetversionnumber
		      		},
					{//获取人脸识别内核版本号
		      			path: '/skface-android-getkernelversion',
				      	name: 'skface-android-getkernelversion',
				      	meta:{type:'document'},
				      	component: SkfaceSdkKernelversion
		      		},
					{//获取Model版本号
		      			path: '/skface-android-getmodelversion',
				      	name: 'skface-android-getmodelversion',
				      	meta:{type:'document'},
				      	component: SkfaceSdkModelEdition
		      		},

					{//视频初始化
		      			path: '/sk-face-sdk-win-voideinitialization',
				      	name: 'sk-face-sdk-win-voideinitialization',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoideinitiali
		      		},
					{//设置“陌生人短时记忆功能”打开、关闭
		      			path: '/sk-face-sdk-win-voideseetingstranger',
				      	name: 'sk-face-sdk-win-voideseetingstranger',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidestranger
		      		},
					{//Video版人脸检测与跟踪
		      			path: '/sk-face-sdk-win-voidedetectiontracking',
				      	name: 'sk-face-sdk-win-voidedetectiontracking',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoideDetection
		      		},
					{//获取FRM绑定信息
		      			path: '/sk-face-sdk-win-voidedefrminformation',
				      	name: 'sk-face-sdk-win-voidedefrminformation',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidefrm
		      		},
					{//获取本机当前绑定信息
		      			path: '/sk-face-sdk-win-voidelocal',
				      	name: 'sk-face-sdk-win-voidelocal',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidelocal
		      		},
					{//绑定frm
		      			path: '/sk-face-sdk-win-voidebindingfrm',
				      	name: 'sk-face-sdk-win-voidebindingfrm',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidebindingfrm
		      		},
					{//解绑frm
		      			path: '/sk-face-sdk-win-voideuntyingfrm',
				      	name: 'sk-face-sdk-win-voideuntyingfrm',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoideuntying
		      		},
					{//设置事件监听
		      			path: '/sk-face-sdk-win-voideseetingmonitor',
				      	name: 'sk-face-sdk-win-voideseetingmonitor',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoideseetingmonitor
		      		},
					{//开始人脸注册
		      			path: '/sk-face-sdk-win-voidefaceregister',
				      	name: 'sk-face-sdk-win-voidefaceregister',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidefaceregister
		      		},
					{//取消人脸注册
		      			path: '/sk-face-sdk-win-voidecancelfaceregister',
				      	name: 'sk-face-sdk-win-voidecancelfaceregister',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidecancelfaceregister
		      		},
					{//获取人的详细信息
		      			path: '/sk-face-sdk-win-voidegetpeople',
				      	name: 'sk-face-sdk-win-voidegetpeople',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidegetpeople
		      		},
					{//设置名字
		      			path: '/sk-face-sdk-win-voidepeoplename',
				      	name: 'sk-face-sdk-win-voidepeoplename',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidepeoplename
		      		},
					{//设置性别
		      			path: '/sk-face-sdk-win-voidesex',
				      	name: 'sk-face-sdk-win-voidesex',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidesex
		      		},
					{//设置生日
		      			path: '/sk-face-sdk-win-voidebrithday',
				      	name: 'sk-face-sdk-win-voidebrithday',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidebrithday
		      		},
					{//设置细节
		      			path: '/sk-face-sdk-win-voidedetails',
				      	name: 'sk-face-sdk-win-voidedetails',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidedetails
		      		},
					  	{//删除一个人
		      			path: '/sk-face-sdk-win-voidedeletepeople',
				      	name: 'sk-face-sdk-win-voidedeletepeople',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidedeletepeople
		      		},
					  	{//获取当前设备所关联人员库Person数量
		      			path: '/sk-face-sdk-win-voidegetperson',
				      	name: 'sk-face-sdk-win-voidegetperson',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidegetperson
		      		},
					  	{//获取认识的人列表
		      			path: '/sk-face-sdk-win-voidepeopleselect',
				      	name: 'sk-face-sdk-win-voidepeopleselect',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidepeopleselect
		      		},
					  	{//获取设备名称
		      			path: '/sk-face-sdk-win-voidesetequipment',
				      	name: 'sk-face-sdk-win-voidesetequipment',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidesetequipment
		      		},
					  	{//获取当前设备所拥有的人员分组结构
		      			path: '/sk-face-sdk-win-voidegrouping',
				      	name: 'sk-face-sdk-win-voidegrouping',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidegrouping
		      		},
					  	{//人员本地ID转换为云端对应ID
		      			path: '/sk-face-sdk-win-voidetransformation',
				      	name: 'sk-face-sdk-win-voidetransformation',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidetransformation
		      		},
					  	{//设置人脸识别阈值
		      			path: '/sk-face-sdk-win-voidethreshold',
				      	name: 'sk-face-sdk-win-voidethreshold',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoidethreshold
		      		},
					  	{//人员的组ID转换为人员所在组的路径
		      			path: '/sk-face-sdk-win-voiderouter',
				      	name: 'sk-face-sdk-win-voiderouter',
				      	meta:{type:'document'},
				      	component: SkfaceSdkAndroidVoiderouter
		      		},
					
		    
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************           SKFaceLive-Windows           *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------基础接口---------------//
		      		{//使用说明
		      			path: '/skface-live-win-userhelp',
				      	name: 'skface-live-win-userhelp',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinHelp
		      		},
		      		{//SDK初始化
		      			path: '/skface-live-win-init',
				      	name: 'skface-live-win-init',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSDKInitial
		      		},
		      		{//释放SDK资源
		      			path: '/skface-live-win-release',
				      	name: 'skface-live-win-release',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinReleaseSDK
		      		},
		      		{//视频人脸检测与跟踪初始化
		      			path: '/skface-live-win-faceinitial',
				      	name: 'skface-live-win-faceinitial',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinFaceInitial
		      		},
		      		{//视频人脸检测与跟踪
		      			path: '/skface-live-win-track',
				      	name: 'skface-live-win-track',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinFaceTrack
		      		},
		      		{//活体视频人脸检测与跟踪
		      			path: '/skface-live-win-facelivetrack',
				      	name: 'skface-live-win-facelivetrack',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinFaceLiveTrack
		      		},
		      		{//视频人证比对与追踪
		      			path: '/skface-live-win-personcardtrack',
				      	name: 'skface-live-win-personcardtrack',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinPersonCardTrack
		      		},
		      		{//设置人脸识别阈值
		      			path: '/skface-live-win-setfacethreshold',
				      	name: 'skface-live-win-setfacethreshold',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSetFace
		      		},
		      		{//获取人脸识别阈值
		      			path: '/skface-live-win-getfacethreshold',
				      	name: 'skface-live-win-getfacethreshold',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetFace
		      		},
		      		{//设置人证比对阈值
		      			path: '/skface-live-win-setpersonandcard',
				      	name: 'skface-live-win-setpersonandcard',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSetPersonAndCard
		      		},
		      		{//获取人证比对阈值
		      			path: '/skface-live-win-getpersonandcard',
				      	name: 'skface-live-win-getpersonandcard',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetPersonAndCard
		      		},
		      		//---------------本地人脸管理接口---------------//
		      		{//开启人脸注册
		      			path: '/skface-live-win-startregisterperson',
				      	name: 'skface-live-win-startregisterperson',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinOpenFaceRegister
		      		},
		      		{//停止人脸注册
		      			path: '/skface-live-win-stopregperson',
				      	name: 'skface-live-win-stopregperson',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinStopFaceRegister
		      		},
		      		{//删除人员信息
		      			path: '/skface-live-win-deleteperson',
				      	name: 'skface-live-win-deleteperson',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinDeletePerson
		      		},
		      		{//设置人脸属性
		      			path: '/skface-live-win-setperson',
				      	name: 'skface-live-win-setperson',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSetFaceAttribute
		      		},
		      		{//设置识别记录的缓存上限
		      			path: '/skface-live-win-setupperlimit',
				      	name: 'skface-live-win-setupperlimit',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSetUpperLimit
		      		},
		      		{//获取认识的人员数量及列表
		      			path: '/skface-live-win-getpersonlist',
				      	name: 'skface-live-win-getpersonlist',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetPersonList
		      		},
		      		{//获取认识人员的详细信息
		      			path: '/skface-live-win-getpersondetails',
				      	name: 'skface-live-win-getpersondetails',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetPersonDetails
		      		},
		      		//---------------事件接口---------------//
		      		{//设置事件监听
		      			path: '/skface-live-win-seteventmonitor',
				      	name: 'skface-live-win-seteventmonitor',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinSetEventMonitor
		      		},
		      		{//短时记忆功能
		      			path: '/skface-live-win-memory',
				      	name: 'skface-live-win-memory',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinShortTimeMemory
		      		},
		      		//---------------FRM相关接口---------------//
		      		{//提取FRM绑定码信息
		      			path: '/skface-live-win-getfrmbindcode',
				      	name: 'skface-live-win-getfrmbindcode',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetFRMBindCode
		      		},
		      		{//绑定FRM
		      			path: '/skface-live-win-bindfrm',
				      	name: 'skface-live-win-bindfrm',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinBindFRM
		      		},
		      		{//解绑FRM
		      			path: '/skface-live-win-untyingfrm',
				      	name: 'skface-live-win-untyingfrm',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinUntyingFRM
		      		},
		      		{//获取本机当前绑定信息
		      			path: '/skface-live-win-getbindinformation',
				      	name: 'skface-live-win-getbindinformation',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetBindInformation
		      		},
		      		{//获取当前终端所拥有的人员分组结构
		      			path: '/skface-live-win-getdeviceallgroup',
				      	name: 'skface-live-win-getdeviceallgroup',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetDeviceAllGroup
		      		},
		      		{//获取FRM终端名称
		      			path: '/skface-live-win-getfrmdevicename',
				      	name: 'skface-live-win-getfrmdevicename',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetFRMDeviceName
		      		},
		      		{//通过人员组ID获得人员组路径信息
		      			path: '/skface-live-win-grouppath',
				      	name: 'skface-live-win-grouppath',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetPath
		      		},
		      		{//人员本地ID转换为云端对应ID
		      			path: '/skface-live-win-personlocalidServerid',
				      	name: 'skface-live-win-personlocalidServerid',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinTransformationID
		      		},
		      		//---------------图片处理相关接口---------------//
		      		{//图片人脸检测与分析
		      			path: '/skface-live-win-imagedetect',
				      	name: 'skface-live-win-imagedetect',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinFaceTesting
		      		},
		      		{//人脸特征对比
		      			path: '/skface-live-win-facecontrast',
				      	name: 'skface-live-win-facecontrast',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinFaceContrast
		      		},
		      		//---------------SDK版本信息接口---------------//
		      		{//获取SDK版本号
		      			path: '/skface-live-win-getsdkversion',
				      	name: 'skface-live-win-getsdkversion',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetSDKVersion
		      		},
		      		{//获取人脸识别内核版本号
		      			path: '/skface-live-win-getfacekernel',
				      	name: 'skface-live-win-getfacekernel',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetFaceKernel
		      		},{//获得Model版本号
		      			path: '/skface-live-win-getmodeversion',
				      	name: 'skface-live-win-getmodeversion',
				      	meta:{type:'document'},
				      	component: SkfaceLiveWinGetModeVersion
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************             SKFace-Windows             *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------基础接口---------------//
		      		{//使用说明
		      			path: '/skface-win-userhelp',
				      	name: 'skface-win-userhelp',
				      	meta:{type:'document'},
				      	component: SkfaceWinHelp
		      		},
		      		{//SDK初始化
		      			path: '/skface-win-init',
				      	name: 'skface-win-init',
				      	meta:{type:'document'},
				      	component: SkfaceWinSDKInitial
		      		},
		      		{//释放SDK资源
		      			path: '/skface-win-release',
				      	name: 'skface-win-release',
				      	meta:{type:'document'},
				      	component: SkfaceWinReleaseSDK
		      		},
		      		{//视频人脸检测与跟踪初始化
		      			path: '/skface-win-faceinitial',
				      	name: 'skface-win-faceinitial',
				      	meta:{type:'document'},
				      	component: SkfaceWinFaceInitial
		      		},
		      		{//视频人脸检测与跟踪
		      			path: '/skface-win-track',
				      	name: 'skface-win-track',
				      	meta:{type:'document'},
				      	component: SkfaceWinFaceTrack
		      		},
		      		// {//活体视频人脸检测与跟踪
		      		// 	path: '/skface-win-facelivetrack',
				      // 	name: 'skface-win-facelivetrack',
				      // 	meta:{type:'document'},
				      // 	component: SkfaceWinFaceLiveTrack
		      		// },
		      		// {//视频人证比对与追踪
		      		// 	path: '/skface-win-personcardtrack',
				      // 	name: 'skface-win-personcardtrack',
				      // 	meta:{type:'document'},
				      // 	component: SkfaceWinPersonCardTrack
		      		// },
		      		{//设置人脸识别阈值
		      			path: '/skface-win-setthreshold',
				      	name: 'skface-win-setthreshold',
				      	meta:{type:'document'},
				      	component: SkfaceWinSetFace
		      		},
		      		{//获取人脸识别阈值
		      			path: '/skface-win-getthreshold',
				      	name: 'skface-win-getthreshold',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetFace
		      		},
		      		// {//设置人证比对阈值
		      		// 	path: '/skface-win-setpersonandcard',
				      // 	name: 'skface-win-setpersonandcard',
				      // 	meta:{type:'document'},
				      // 	component: SkfaceWinSetPersonAndCard
		      		// },
		      		// {//获取人证比对阈值
		      		// 	path: '/skface-win-getpersonandcard',
				      // 	name: 'skface-win-getpersonandcard',
				      // 	meta:{type:'document'},
				      // 	component: SkfaceWinGetPersonAndCard
		      		// },
		      		//---------------本地人脸管理接口---------------//
		      		{//开启人脸注册
		      			path: '/skface-win-startregisterperson',
				      	name: 'skface-win-startregisterperson',
				      	meta:{type:'document'},
				      	component: SkfaceWinOpenFaceRegister
		      		},
		      		{//停止人脸注册
		      			path: '/skface-win-stopregperson',
				      	name: 'skface-win-stopregperson',
				      	meta:{type:'document'},
				      	component: SkfaceWinStopFaceRegister
		      		},
		      		{//删除人员信息
		      			path: '/skface-win-deleteperson',
				      	name: 'skface-win-deleteperson',
				      	meta:{type:'document'},
				      	component: SkfaceWinDeletePerson
		      		},
		      		{//设置人脸属性
		      			path: '/skface-win-setperson',
				      	name: 'skface-win-setperson',
				      	meta:{type:'document'},
				      	component: SkfaceWinSetFaceAttribute
		      		},
		      		{//设置识别记录的缓存上限
		      			path: '/skface-win-setuploadbuffer',
				      	name: 'skface-win-setuploadbuffer',
				      	meta:{type:'document'},
				      	component: SkfaceWinSetUpperLimit
		      		},
		      		{//获取认识的人员数量及列表
		      			path: '/skface-win-getpersonlist',
				      	name: 'skface-win-getpersonlist',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetPersonList
		      		},
		      		{//获取认识人员的详细信息
		      			path: '/skface-win-getpersondetails',
				      	name: 'skface-win-getpersondetails',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetPersonDetails
		      		},
		      		//---------------事件接口---------------//
		      		{//设置事件监听
		      			path: '/skface-win-seteventmonitor',
				      	name: 'skface-win-seteventmonitor',
				      	meta:{type:'document'},
				      	component: SkfaceWinSetEventMonitor
		      		},
		      		{//短时记忆功能
		      			path: '/skface-win-memory',
				      	name: 'skface-win-memory',
				      	meta:{type:'document'},
				      	component: SkfaceWinShortTimeMemory
		      		},
		      		//---------------FRM相关接口---------------//
		      		{//提取FRM绑定码信息
		      			path: '/skface-win-getfrmbindcode',
				      	name: 'skface-win-getfrmbindcode',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetFRMBindCode
		      		},
		      		{//绑定FRM
		      			path: '/skface-win-bindfrm',
				      	name: 'skface-win-bindfrm',
				      	meta:{type:'document'},
				      	component: SkfaceWinBindFRM
		      		},
		      		{//解绑FRM
		      			path: '/skface-win-untyingfrm',
				      	name: 'skface-win-untyingfrm',
				      	meta:{type:'document'},
				      	component: SkfaceWinUntyingFRM
		      		},
		      		{//获取本机当前绑定信息
		      			path: '/skface-win-getbindinformation',
				      	name: 'skface-win-getbindinformation',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetBindInformation
		      		},
		      		{//获取当前终端所拥有的人员分组结构
		      			path: '/skface-win-getdeviceallgroup',
				      	name: 'skface-win-getdeviceallgroup',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetDeviceAllGroup
		      		},
		      		{//获取FRM终端名称
		      			path: '/skface-win-getfrmdevicename',
				      	name: 'skface-win-getfrmdevicename',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetFRMDeviceName
		      		},
		      		{//通过人员组ID获得人员组路径信息
		      			path: '/skface-win-grouppath',
				      	name: 'skface-win-grouppath',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetPath
		      		},
		      		{//人员本地ID转换为云端对应ID
		      			path: '/skface-win-personlocalidServerid',
				      	name: 'skface-win-personlocalidServerid',
				      	meta:{type:'document'},
				      	component: SkfaceWinTransformationID
		      		},
		      		//---------------图片处理相关接口---------------//
		      		{//图片人脸检测与分析
		      			path: '/skface-win-imagedetect',
				      	name: 'skface-win-imagedetect',
				      	meta:{type:'document'},
				      	component: SkfaceWinFaceTesting
		      		},
		      		{//人脸特征对比
		      			path: '/skface-win-facecontrast',
				      	name: 'skface-win-facecontrast',
				      	meta:{type:'document'},
				      	component: SkfaceWinFaceContrast
		      		},
		      		//---------------SDK版本信息接口---------------//
		      		{//获取SDK版本号
		      			path: '/skface-win-getsdkversion',
				      	name: 'skface-win-getsdkversion',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetSDKVersion
		      		},
		      		{//获取人脸识别内核版本号
		      			path: '/skface-win-getfacekernel',
				      	name: 'skface-win-getfacekernel',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetFaceKernel
		      		},{//获得Model版本号
		      			path: '/skface-win-getmodeversion',
				      	name: 'skface-win-getmodeversion',
				      	meta:{type:'document'},
				      	component: SkfaceWinGetModeVersion
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                SKEye-iOS              *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------iOS物体识别---------------//
		      		{//使用说明
		      			path: '/skeye-ios-userhelp',
				      	name: 'skeye-ios-userhelp',
				      	meta:{type:'document'},
				      	component: SKEyeiOSUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skeye-ios-init',
				      	name: 'skeye-ios-init',
				      	meta:{type:'document'},
				      	component: SKEyeiOSSDKInitial
		      		},
		      		{//调用图像识别接口
		      			path: '/skeye-ios-image',
				      	name: 'skeye-ios-image',
				      	meta:{type:'document'},
				      	component: SKEyeiOScallImageInterface
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                SKEye-Android           *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------Android物体识别---------------//
		      		{//使用说明
		      			path: '/skeye-android-userhelp',
				      	name: 'skeye-android-userhelp',
				      	meta:{type:'document'},
				      	component: SKEyeAndroidUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skeye-android-init',
				      	name: 'skeye-android-init',
				      	meta:{type:'document'},
				      	component: SKEyeAndroidSDKInitial
		      		},
		      		{//图像偏色处理
		      			path: '/skeye-android-colorcast',
				      	name: 'skeye-android-colorcast',
				      	meta:{type:'document'},
				      	component: SKEyeAndroidImageBias
		      		},
		      		{//调用图像识别接口
		      			path: '/skeye-android-image',
				      	name: 'skeye-android-image',
				      	meta:{type:'document'},
				      	component: SKEyeAndroidCallImageInterface
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                 SKEye-Linux            *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//--------------Linux 物体识别---------------//
		      		{//使用说明
		      			path: '/skeye-linux-userhelp',
				      	name: 'Documents/skeye-linux-userhelp',
				      	meta:{type:'document'},
				      	component: SKEyeLinuxUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skeye-linux-init',
				      	name: 'skeye-linux-init',
				      	meta:{type:'document'},
				      	component: SKEyeLinuxSDKInitial
		      		},
		      		{//调用图像识别接口
		      			path: '/skeye-linux-image',
				      	name: 'skeye-linux-image',
				      	meta:{type:'document'},
				      	component: SKEyeLinuxCallImageInterface
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************              SKEye-Windows             *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------Windows物体识别---------------//
		      		{//使用说明
		      			path: '/skeye-win-userhelp',
				      	name: 'skeye-win-userhelp',
				      	meta:{type:'document'},
				      	component: SKEyeWinUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skeye-win-init',
				      	name: 'skeye-win-init',
				      	meta:{type:'document'},
				      	component: SKEyeWinSDKInitial
		      		},
		      		{//调用图像识别接口
		      			path: '/skeye-win-image',
				      	name: 'skeye-win-image',
				      	meta:{type:'document'},
				      	component: SKEyeWinCallImageInterface
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************               SKEye-Unity              *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------Windows物体识别---------------//
		      		{//使用说明
		      			path: '/skeye-unity-userhelp',
				      	name: 'skeye-unity-userhelp',
				      	meta:{type:'document'},
				      	component: SKEyeUnityUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skeye-unity-init',
				      	name: 'skeye-unity-init',
				      	meta:{type:'document'},
				      	component: SKEyeUnitySDKInitial
		      		},
		      		{//调用图像识别接口
		      			path: '/skeye-unity-image',
				      	name: 'skeye-unity-image',
				      	meta:{type:'document'},
				      	component: SKEyeUnityCallImageInterface
		      		},
		      		//******************************************************************************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************             SKObjects-API              *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//*******************                                        *******************//
		      		//******************************************************************************//
		      		//---------------Windows物体识别---------------//
		      		{//使用说明
		      			path: '/skobj-api-userhelp',
				      	name: 'skobj-api-userhelp',
				      	meta:{type:'document'},
				      	component: SKObjectsUserHelp
		      		},
		      		{//SDK初始化
		      			path: '/skobj-api-objectsapi',
				      	name: 'skobj-api-objectsapi',
				      	meta:{type:'document'},
				      	component: SKObjectsApi
		      		},
		      	]
		    },
	    ],
    },
    
]

const router = new VueRouter({
	// mode: 'history',//'hash'则一切正常
	routes
})
router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0)
	next()
	
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js